<script>
import { LensSelected } from "./store.js";
function changeLens(newLens) {
  LensSelected.set(newLens);
}
</script>


<head>
<meta http-equiv="content-type" content="text/html; charset=UTF-8"><script type="text/javascript" src="content/300lo.json"></script><script type="text/javascript" src="content/_ate"></script>
	<title>InfoABS 2017 - ASPB - Agència de Salut Pública de Barcelona</title>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
	<!--[if lt IE 9]>
	<script src="http://css3-mediaqueries-js.googlecode.com/svn/trunk/css3-mediaqueries.js"></script>
	<script src="http://html5shiv.googlecode.com/svn/trunk/html5.js"></script>
	<script src="https://oss.maxcdn.com/libs/respond.js/1.3.0/respond.min.js"></script>
	<![endif]-->
	<link rel="alternate" hreflang="ca" href="https://www.aspb.cat/documents/infoabs-2017/">

<!-- This site is optimized with the Yoast SEO Premium plugin v12.1 - https://yoast.com/wordpress/plugins/seo/ -->
<link rel="canonical" href="https://www.aspb.cat/documents/infoabs-2017/">
<meta property="og:locale" content="ca_ES">
<meta property="og:type" content="article">
<meta property="og:title" content="InfoABS 2017 - ASPB - Agència de Salut Pública de Barcelona">
<meta property="og:description" content="Conjunt d’indicadors de salut i els seus determinants per Àrees Bàsiques de Salut (ABS) l’any …">
<meta property="og:url" content="https://www.aspb.cat/documents/infoabs-2017/">
<meta property="og:site_name" content="ASPB - Agència de Salut Pública de Barcelona">
<meta property="article:publisher" content="https://www.facebook.com/salutpublicabcn">
<meta property="og:image" content="https://www.aspb.cat/wp-content/uploads/2018/09/infoABSMesa_2017.png">
<meta property="og:image:secure_url" content="https://www.aspb.cat/wp-content/uploads/2018/09/infoABSMesa_2017.png">
<meta property="og:image:width" content="613">
<meta property="og:image:height" content="860">
<meta name="twitter:card" content="summary">
<meta name="twitter:description" content="Conjunt d’indicadors de salut i els seus determinants per Àrees Bàsiques de Salut (ABS) l’any […]">
<meta name="twitter:title" content="InfoABS 2017 - ASPB - Agència de Salut Pública de Barcelona">
<meta name="twitter:site" content="@salutpublicabcn">
<meta name="twitter:image" content="https://www.aspb.cat/wp-content/uploads/2018/09/infoABSMesa_2017.png">
<meta name="twitter:creator" content="@salutpublicabcn">
<script type="text/javascript" async="" src="content/recaptcha__en.js"></script><script async="" src="content/analytics.js"></script><script type="application/ld+json" class="yoast-schema-graph yoast-schema-graph--main">{"@context":"https://schema.org","@graph":[{"@type":"WebSite","@id":"https://www.aspb.cat/#website","url":"https://www.aspb.cat/","name":"ASPB - Ag\u00e8ncia de Salut P\u00fablica de Barcelona","potentialAction":{"@type":"SearchAction","target":"https://www.aspb.cat/?s={search_term_string}","query-input":"required name=search_term_string"}},{"@type":"ImageObject","@id":"https://www.aspb.cat/documents/infoabs-2017/#primaryimage","url":"https://www.aspb.cat/wp-content/uploads/2018/09/infoABSMesa_2017.png","width":"613","height":"860"},{"@type":"WebPage","@id":"https://www.aspb.cat/documents/infoabs-2017/#webpage","url":"https://www.aspb.cat/documents/infoabs-2017/","inLanguage":"ca","name":"InfoABS 2017 - ASPB - Ag\u00e8ncia de Salut P\u00fablica de Barcelona","isPartOf":{"@id":"https://www.aspb.cat/#website"},"primaryImageOfPage":{"@id":"https://www.aspb.cat/documents/infoabs-2017/#primaryimage"},"datePublished":"2018-09-14T17:03:50+00:00","dateModified":"2018-10-04T14:16:54+00:00"}]}</script>
<!-- / Yoast SEO Premium plugin. -->

<link rel="dns-prefetch" href="https://s.w.org/">
<link rel="shortcut icon" href="https://www.aspb.cat/wp-content/themes/aspb/images/favicon.ico" type="image/vnd.microsoft.icon"><link rel="icon" href="https://www.aspb.cat/wp-content/themes/aspb/images/favicon.ico" type="image/x-ico">
	<!-- This site uses the Google Analytics by MonsterInsights plugin v7.8.2 - Using Analytics tracking - https://www.monsterinsights.com/ -->
<script type="text/javascript" data-cfasync="false">
	var mi_version         = '7.8.2';
	var mi_track_user      = true;
	var mi_no_track_reason = '';
	
	var disableStr = 'ga-disable-UA-166291-4';
	/* Function to detect opted out users */
	function __gaTrackerIsOptedOut() {
		return document.cookie.indexOf(disableStr + '=true') > -1;
	}
	/* Disable tracking if the opt-out cookie exists. */
	if ( __gaTrackerIsOptedOut() ) {
		window[disableStr] = true;
	}
	/* Opt-out function */
	function __gaTrackerOptout() {
	  document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
	  window[disableStr] = true;
	}
	
	if ( mi_track_user ) {
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
			(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
			m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','//www.google-analytics.com/analytics.js','__gaTracker');
		__gaTracker('create', 'UA-166291-4', 'auto');
		__gaTracker('set', 'forceSSL', true);
		__gaTracker('require', 'displayfeatures');
		__gaTracker('send','pageview');
	} else {
		console.log( "" );
		(function() {
			/* https://developers.google.com/analytics/devguides/collection/analyticsjs/ */
			var noopfn = function() {
				return null;
			};
			var noopnullfn = function() {
				return null;
			};
			var Tracker = function() {
				return null;
			};
			var p = Tracker.prototype;
			p.get = noopfn;
			p.set = noopfn;
			p.send = noopfn;
			var __gaTracker = function() {
				var len = arguments.length;
				if ( len === 0 ) {
					return;
				}
				var f = arguments[len-1];
				if ( typeof f !== 'object' || f === null || typeof f.hitCallback !== 'function' ) {
					console.log( 'Not running function __gaTracker(' + arguments[0] + " ....) because you are not being tracked. " + mi_no_track_reason );
					return;
				}
				try {
					f.hitCallback();
				} catch (ex) {
				}
			};
			__gaTracker.create = function() {
				return new Tracker();
			};
			__gaTracker.getByName = noopnullfn;
			__gaTracker.getAll = function() {
				return [];
			};
			__gaTracker.remove = noopfn;
			window['__gaTracker'] = __gaTracker;
					})();
		}
</script>
<!-- / Google Analytics by MonsterInsights -->
		<script type="text/javascript">
			window._wpemojiSettings = {"baseUrl":"https:\/\/s.w.org\/images\/core\/emoji\/12.0.0-1\/72x72\/","ext":".png","svgUrl":"https:\/\/s.w.org\/images\/core\/emoji\/12.0.0-1\/svg\/","svgExt":".svg","source":{"concatemoji":"https:\/\/www.aspb.cat\/wp-includes\/js\/wp-emoji-release.min.js?ver=6e0d00aef3d8780eef8dedcc6a1bc7a4"}};
			!function(a,b,c){function d(a,b){var c=String.fromCharCode;l.clearRect(0,0,k.width,k.height),l.fillText(c.apply(this,a),0,0);var d=k.toDataURL();l.clearRect(0,0,k.width,k.height),l.fillText(c.apply(this,b),0,0);var e=k.toDataURL();return d===e}function e(a){var b;if(!l||!l.fillText)return!1;switch(l.textBaseline="top",l.font="600 32px Arial",a){case"flag":return!(b=d([55356,56826,55356,56819],[55356,56826,8203,55356,56819]))&&(b=d([55356,57332,56128,56423,56128,56418,56128,56421,56128,56430,56128,56423,56128,56447],[55356,57332,8203,56128,56423,8203,56128,56418,8203,56128,56421,8203,56128,56430,8203,56128,56423,8203,56128,56447]),!b);case"emoji":return b=d([55357,56424,55356,57342,8205,55358,56605,8205,55357,56424,55356,57340],[55357,56424,55356,57342,8203,55358,56605,8203,55357,56424,55356,57340]),!b}return!1}function f(a){var c=b.createElement("script");c.src=a,c.defer=c.type="text/javascript",b.getElementsByTagName("head")[0].appendChild(c)}var g,h,i,j,k=b.createElement("canvas"),l=k.getContext&&k.getContext("2d");for(j=Array("flag","emoji"),c.supports={everything:!0,everythingExceptFlag:!0},i=0;i<j.length;i++)c.supports[j[i]]=e(j[i]),c.supports.everything=c.supports.everything&&c.supports[j[i]],"flag"!==j[i]&&(c.supports.everythingExceptFlag=c.supports.everythingExceptFlag&&c.supports[j[i]]);c.supports.everythingExceptFlag=c.supports.everythingExceptFlag&&!c.supports.flag,c.DOMReady=!1,c.readyCallback=function(){c.DOMReady=!0},c.supports.everything||(h=function(){c.readyCallback()},b.addEventListener?(b.addEventListener("DOMContentLoaded",h,!1),a.addEventListener("load",h,!1)):(a.attachEvent("onload",h),b.attachEvent("onreadystatechange",function(){"complete"===b.readyState&&c.readyCallback()})),g=c.source||{},g.concatemoji?f(g.concatemoji):g.wpemoji&&g.twemoji&&(f(g.twemoji),f(g.wpemoji)))}(window,document,window._wpemojiSettings);
		</script><script src="content/wp-emoji-release.js" type="text/javascript" defer="defer"></script>
		<style type="text/css">
img.wp-smiley,
img.emoji {
	display: inline !important;
	border: none !important;
	box-shadow: none !important;
	height: 1em !important;
	width: 1em !important;
	margin: 0 .07em !important;
	vertical-align: -0.1em !important;
	background: none !important;
	padding: 0 !important;
}
</style>
	<link rel="stylesheet" id="aspb_cached-css" href="content/cached.css" type="text/css" media="all">
<link rel="https://api.w.org/" href="https://www.aspb.cat/wp-json/">
<link rel="alternate" type="application/json+oembed" href="https://www.aspb.cat/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.aspb.cat%2Fdocuments%2Finfoabs-2017%2F">
<link rel="alternate" type="text/xml+oembed" href="https://www.aspb.cat/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.aspb.cat%2Fdocuments%2Finfoabs-2017%2F&amp;format=xml">
<meta name="generator" content="WPML ver:4.2.1 stt:8;">
<link rel="icon" href="https://www.aspb.cat/wp-content/uploads/2016/07/cropped-iconaspb-32x32.jpeg" sizes="32x32">
<link rel="icon" href="https://www.aspb.cat/wp-content/uploads/2016/07/cropped-iconaspb-192x192.jpeg" sizes="192x192">
<link rel="apple-touch-icon-precomposed" href="https://www.aspb.cat/wp-content/uploads/2016/07/cropped-iconaspb-180x180.jpeg">
<meta name="msapplication-TileImage" content="https://www.aspb.cat/wp-content/uploads/2016/07/cropped-iconaspb-270x270.jpeg">


	<link rel="stylesheet" type="text/css" href="content/bcn-avisos.css" media="all">
	<script type="text/javascript" src="content/bcn-avisos.js"></script>

<script type="text/javascript" src="content/be.js"></script><style type="text/css">.at-icon{fill:#fff;border:0}.at-icon-wrapper{display:inline-block;overflow:hidden}a .at-icon-wrapper{cursor:pointer}.at-rounded,.at-rounded-element .at-icon-wrapper{border-radius:12%}.at-circular,.at-circular-element .at-icon-wrapper{border-radius:50%}.addthis_32x32_style .at-icon{width:2pc;height:2pc}.addthis_24x24_style .at-icon{width:24px;height:24px}.addthis_20x20_style .at-icon{width:20px;height:20px}.addthis_16x16_style .at-icon{width:1pc;height:1pc}#at16lb{display:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:1001;background-color:#000;opacity:.001}#at_complete,#at_error,#at_share,#at_success{position:static!important}.at15dn{display:none}#at15s,#at16p,#at16p form input,#at16p label,#at16p textarea,#at_share .at_item{font-family:arial,helvetica,tahoma,verdana,sans-serif!important;font-size:9pt!important;outline-style:none;outline-width:0;line-height:1em}* html #at15s.mmborder{position:absolute!important}#at15s.mmborder{position:fixed!important;width:250px!important}#at15s{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABtJREFUeNpiZGBgaGAgAjAxEAlGFVJHIUCAAQDcngCUgqGMqwAAAABJRU5ErkJggg==);float:none;line-height:1em;margin:0;overflow:visible;padding:5px;text-align:left;position:absolute}#at15s a,#at15s span{outline:0;direction:ltr;text-transform:none}#at15s .at-label{margin-left:5px}#at15s .at-icon-wrapper{width:1pc;height:1pc;vertical-align:middle}#at15s .at-icon{width:1pc;height:1pc}.at4-icon{display:inline-block;background-repeat:no-repeat;background-position:top left;margin:0;overflow:hidden;cursor:pointer}.addthis_16x16_style .at4-icon,.addthis_default_style .at4-icon,.at4-icon,.at-16x16{width:1pc;height:1pc;line-height:1pc;background-size:1pc!important}.addthis_32x32_style .at4-icon,.at-32x32{width:2pc;height:2pc;line-height:2pc;background-size:2pc!important}.addthis_24x24_style .at4-icon,.at-24x24{width:24px;height:24px;line-height:24px;background-size:24px!important}.addthis_20x20_style .at4-icon,.at-20x20{width:20px;height:20px;line-height:20px;background-size:20px!important}.at4-icon.circular,.circular .at4-icon,.circular.aticon{border-radius:50%}.at4-icon.rounded,.rounded .at4-icon{border-radius:4px}.at4-icon-left{float:left}#at15s .at4-icon{text-indent:20px;padding:0;overflow:visible;white-space:nowrap;background-size:1pc;width:1pc;height:1pc;background-position:top left;display:inline-block;line-height:1pc}.addthis_vertical_style .at4-icon,.at4-follow-container .at4-icon{margin-right:5px}html>body #at15s{width:250px!important}#at15s.atm{background:none!important;padding:0!important;width:10pc!important}#at15s_inner{background:#fff;border:1px solid #fff;margin:0}#at15s_head{position:relative;background:#f2f2f2;padding:4px;cursor:default;border-bottom:1px solid #e5e5e5}.at15s_head_success{background:#cafd99!important;border-bottom:1px solid #a9d582!important}.at15s_head_success a,.at15s_head_success span{color:#000!important;text-decoration:none}#at15s_brand,#at15sptx,#at16_brand{position:absolute}#at15s_brand{top:4px;right:4px}.at15s_brandx{right:20px!important}a#at15sptx{top:4px;right:4px;text-decoration:none;color:#4c4c4c;font-weight:700}#at15sptx:hover{text-decoration:underline}#at16_brand{top:5px;right:30px;cursor:default}#at_hover{padding:4px}#at_hover .at_item,#at_share .at_item{background:#fff!important;float:left!important;color:#4c4c4c!important}#at_share .at_item .at-icon-wrapper{margin-right:5px}#at_hover .at_bold{font-weight:700;color:#000!important}#at_hover .at_item{width:7pc!important;padding:2px 3px!important;margin:1px;text-decoration:none!important}#at_hover .at_item.athov,#at_hover .at_item:focus,#at_hover .at_item:hover{margin:0!important}#at_hover .at_item.athov,#at_hover .at_item:focus,#at_hover .at_item:hover,#at_share .at_item.athov,#at_share .at_item:hover{background:#f2f2f2!important;border:1px solid #e5e5e5;color:#000!important;text-decoration:none}.ipad #at_hover .at_item:focus{background:#fff!important;border:1px solid #fff}.at15t{display:block!important;height:1pc!important;line-height:1pc!important;padding-left:20px!important;background-position:0 0;text-align:left}.addthis_button,.at15t{cursor:pointer}.addthis_toolbox a.at300b,.addthis_toolbox a.at300m{width:auto}.addthis_toolbox a{margin-bottom:5px;line-height:initial}.addthis_toolbox.addthis_vertical_style{width:200px}.addthis_button_facebook_like .fb_iframe_widget{line-height:100%}.addthis_button_facebook_like iframe.fb_iframe_widget_lift{max-width:none}.addthis_toolbox a.addthis_button_counter,.addthis_toolbox a.addthis_button_facebook_like,.addthis_toolbox a.addthis_button_facebook_send,.addthis_toolbox a.addthis_button_facebook_share,.addthis_toolbox a.addthis_button_foursquare,.addthis_toolbox a.addthis_button_linkedin_counter,.addthis_toolbox a.addthis_button_pinterest_pinit,.addthis_toolbox a.addthis_button_tweet{display:inline-block}.addthis_toolbox span.addthis_follow_label{display:none}.addthis_toolbox.addthis_vertical_style span.addthis_follow_label{display:block;white-space:nowrap}.addthis_toolbox.addthis_vertical_style a{display:block}.addthis_toolbox.addthis_vertical_style.addthis_32x32_style a{line-height:2pc;height:2pc}.addthis_toolbox.addthis_vertical_style .at300bs{margin-right:4px;float:left}.addthis_toolbox.addthis_20x20_style span{line-height:20px}.addthis_toolbox.addthis_32x32_style span{line-height:2pc}.addthis_toolbox.addthis_pill_combo_style .addthis_button_compact .at15t_compact,.addthis_toolbox.addthis_pill_combo_style a{float:left}.addthis_toolbox.addthis_pill_combo_style a.addthis_button_tweet{margin-top:-2px}.addthis_toolbox.addthis_pill_combo_style .addthis_button_compact .at15t_compact{margin-right:4px}.addthis_default_style .addthis_separator{margin:0 5px;display:inline}div.atclear{clear:both}.addthis_default_style .addthis_separator,.addthis_default_style .at4-icon,.addthis_default_style .at300b,.addthis_default_style .at300bo,.addthis_default_style .at300bs,.addthis_default_style .at300m{float:left}.at300b img,.at300bo img{border:0}a.at300b .at4-icon,a.at300m .at4-icon{display:block}.addthis_default_style .at300b,.addthis_default_style .at300bo,.addthis_default_style .at300m{padding:0 2px}.at300b,.at300bo,.at300bs,.at300m{cursor:pointer}.addthis_button_facebook_like.at300b:hover,.addthis_button_facebook_like.at300bs:hover,.addthis_button_facebook_send.at300b:hover,.addthis_button_facebook_send.at300bs:hover{opacity:1}.addthis_20x20_style .at15t,.addthis_20x20_style .at300bs{overflow:hidden;display:block;height:20px!important;width:20px!important;line-height:20px!important}.addthis_32x32_style .at15t,.addthis_32x32_style .at300bs{overflow:hidden;display:block;height:2pc!important;width:2pc!important;line-height:2pc!important}.at300bs{overflow:hidden;display:block;background-position:0 0;height:1pc;width:1pc;line-height:1pc!important}.addthis_default_style .at15t_compact,.addthis_default_style .at15t_expanded{margin-right:4px}#at_share .at_item{width:123px!important;padding:4px;margin-right:2px;border:1px solid #fff}#at16p{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABtJREFUeNpiZGBgaGAgAjAxEAlGFVJHIUCAAQDcngCUgqGMqwAAAABJRU5ErkJggg==);z-index:10000001;position:absolute;top:50%;left:50%;width:300px;padding:10px;margin:0 auto;margin-top:-185px;margin-left:-155px;font-family:arial,helvetica,tahoma,verdana,sans-serif;font-size:9pt;color:#5e5e5e}#at_share{margin:0;padding:0}#at16pt{position:relative;background:#f2f2f2;height:13px;padding:5px 10px}#at16pt a,#at16pt h4{font-weight:700}#at16pt h4{display:inline;margin:0;padding:0;font-size:9pt;color:#4c4c4c;cursor:default}#at16pt a{position:absolute;top:5px;right:10px;color:#4c4c4c;text-decoration:none;padding:2px}#at15sptx:focus,#at16pt a:focus{outline:thin dotted}#at15s #at16pf a{top:1px}#_atssh{width:1px!important;height:1px!important;border:0!important}.atm{width:10pc!important;padding:0;margin:0;line-height:9pt;letter-spacing:normal;font-family:arial,helvetica,tahoma,verdana,sans-serif;font-size:9pt;color:#444;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABtJREFUeNpiZGBgaGAgAjAxEAlGFVJHIUCAAQDcngCUgqGMqwAAAABJRU5ErkJggg==);padding:4px}.atm-f{text-align:right;border-top:1px solid #ddd;padding:5px 8px}.atm-i{background:#fff;border:1px solid #d5d6d6;padding:0;margin:0;box-shadow:1px 1px 5px rgba(0,0,0,.15)}.atm-s{margin:0!important;padding:0!important}.atm-s a:focus{border:transparent;outline:0;transition:none}#at_hover.atm-s a,.atm-s a{display:block;text-decoration:none;padding:4px 10px;color:#235dab!important;font-weight:400;font-style:normal;transition:none}#at_hover.atm-s .at_bold{color:#235dab!important}#at_hover.atm-s a:hover,.atm-s a:hover{background:#2095f0;text-decoration:none;color:#fff!important}#at_hover.atm-s .at_bold{font-weight:700}#at_hover.atm-s a:hover .at_bold{color:#fff!important}.atm-s a .at-label{vertical-align:middle;margin-left:5px;direction:ltr}.at_PinItButton{display:block;width:40px;height:20px;padding:0;margin:0;background-image:url(//s7.addthis.com/static/t00/pinit00.png);background-repeat:no-repeat}.at_PinItButton:hover{background-position:0 -20px}.addthis_toolbox .addthis_button_pinterest_pinit{position:relative}.at-share-tbx-element .fb_iframe_widget span{vertical-align:baseline!important}#at16pf{height:auto;text-align:right;padding:4px 8px}.at-privacy-info{position:absolute;left:7px;bottom:7px;cursor:pointer;text-decoration:none;font-family:helvetica,arial,sans-serif;font-size:10px;line-height:9pt;letter-spacing:.2px;color:#666}.at-privacy-info:hover{color:#000}.body .wsb-social-share .wsb-social-share-button-vert{padding-top:0;padding-bottom:0}.body .wsb-social-share.addthis_counter_style .addthis_button_tweet.wsb-social-share-button{padding-top:40px}.body .wsb-social-share.addthis_counter_style .addthis_button_facebook_like.wsb-social-share-button{padding-top:21px}@media print{#at4-follow,#at4-share,#at4-thankyou,#at4-whatsnext,#at4m-mobile,#at15s,.at4,.at4-recommended{display:none!important}}@media screen and (max-width:400px){.at4win{width:100%}}@media screen and (max-height:700px) and (max-width:400px){.at4-thankyou-inner .at4-recommended-container{height:122px;overflow:hidden}.at4-thankyou-inner .at4-recommended .at4-recommended-item:first-child{border-bottom:1px solid #c5c5c5}}</style><style type="text/css">.at-branding-logo{font-family:helvetica,arial,sans-serif;text-decoration:none;font-size:10px;display:inline-block;margin:2px 0;letter-spacing:.2px}.at-branding-logo .at-branding-icon{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRF////+GlNUkcc1QAAAB1JREFUeNpiYIQDBjQmAwMmkwEM0JnY1WIxFyDAABGeAFEudiZsAAAAAElFTkSuQmCC")}.at-branding-logo .at-branding-icon,.at-branding-logo .at-privacy-icon{display:inline-block;height:10px;width:10px;margin-left:4px;margin-right:3px;margin-bottom:-1px;background-repeat:no-repeat}.at-branding-logo .at-privacy-icon{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAMAAABR24SMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABhQTFRF8fr9ot/xXcfn2/P5AKva////////AKTWodjhjAAAAAd0Uk5T////////ABpLA0YAAAA6SURBVHjaJMzBDQAwCAJAQaj7b9xifV0kUKJ9ciWxlzWEWI5gMF65KUTv0VKkjVeTerqE/x7+9BVgAEXbAWI8QDcfAAAAAElFTkSuQmCC")}.at-branding-logo span{text-decoration:none}.at-branding-logo .at-branding-addthis,.at-branding-logo .at-branding-powered-by{color:#666}.at-branding-logo .at-branding-addthis:hover{color:#333}.at-cv-with-image .at-branding-addthis,.at-cv-with-image .at-branding-addthis:hover{color:#fff}a.at-branding-logo:visited{color:initial}.at-branding-info{display:inline-block;padding:0 5px;color:#666;border:1px solid #666;border-radius:50%;font-size:10px;line-height:9pt;opacity:.7;transition:all .3s ease;text-decoration:none}.at-branding-info span{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.at-branding-info:before{content:'i';font-family:Times New Roman}.at-branding-info:hover{color:#0780df;border-color:#0780df}</style></head>



<body class="documento-template-default single single-documento postid-9513 firefox firefox68_0 firefox68 linux lang_ca">

<div id="pagina" class="author-adaspbuser1">

	<section class="wrapper" id="cabecera_wrapper">
		<div id="cabecera">

			<div id="bcnavisos"></div>

			<div class="inner_wrapper">

				<div id="cabecera_izquierda" style="visibility: visible;"><ul></ul></div>

								<div class="logo">
					<a href="https://www.aspb.cat/" title="ASPB - Agència de Salut Pública de Barcelona" rel="start">
						<img src="content/agencia-salut-publica.png" alt="ASPB - Agència de Salut Pública de Barcelona" title="ASPB - Agència de Salut Pública de Barcelona">
					</a>
				</div>

				<div id="cabecera_derecha">
					<ul><li id="text_icl-3" class="widget widget_text_icl">		<div class="textwidget"><ul class="social_bar">
<li class="facebook"><a href="https://www.facebook.com/salutpublicabcn" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
<li class="twitter"><a href="https://twitter.com/salutpublicabcn" target="_blank"> <i class="fa fa-twitter" aria-hidden="true"></i>
 </a></li>
<li class="youtube"><a href="https://www.youtube.com/channel/UC1qJ5wfnP7fcT9pXkoe9opA" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
<li class="slideshare"><a href="http://www.slideshare.net/SalutpublicaBCN/" target="_blank"><i class="fa fa-slideshare" aria-hidden="true"></i></a></li>
<li class="linkedin"><a href="https://www.linkedin.com/company/ag%C3%A8ncia-de-salut-p%C3%BAblica-de-barcelona---aspb" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
</ul></div>
		</li></ul>
											<div id="boletin"><a href="https://www.aspb.cat/butlleti/">Subscriu-te al butlletí <i class="fa fa-envelope" aria-hidden="true"></i></a></div>
									</div>

			</div>
			<div id="bcnavisos"></div>
			<div class="acceso_directo"><a href="#contenido" title="Anar al contingut">Anar al contingut</a></div>

			<nav id="menu_principal" class="menu">
								<div class="inner_wrapper">
					<nav id="main_mobile"><a href="javascript://" class="lanzador_menu"></a></nav>
					<nav id="main">
						<ul>
							<li class="inici"><a href="https://www.aspb.cat/">Inicio</a></li>
																	<li><a href="javascript://" class="link_children" data-id="nav_22">L' Agència</a><ul>
							
												<li><a href="https://www.aspb.cat/l-agencia/qui-som/">Qui som</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/on-som/">On som</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/qualitat/">Gestió de serveis</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_28">Portal de transparència</a><ul>
							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/informacio-institucional-organitzativa/">Informació institucional i organitzativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/plans-i-objectius/">Plans i objectius</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/documents-de-referencia/">Documents de referència</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/gestio-economica-administrativa/">Gestió econòmica i administrativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/participacio-relacio-ciutadania/">Participació i relació amb la ciutadania</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/dret-dacces-informacio-publica/">Dret d’accés a la informació pública</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/comunicacio-i-imatge/">Imatge corporativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/treballar-aspb/">Treballar a l'ASPB</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/proveidors/">Proveïdors i perfil del contractant</a></li>

							
												<li><a href="https://www.aspb.cat/noticies/">Notícies</a></li>

							
												<li><a href="https://www.aspb.cat/agenda">Activitats</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/premsa/">Premsa</a></li>

													</ul></li>
																	<li><a href="javascript://" class="link_children" data-id="nav_53">Àrees</a><ul>
																			<li><a href="javascript://" class="link_children" data-id="nav_55">La Salut en xifres</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/salut-barcelona/">La salut a Barcelona</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-als-districtes/">La salut als districtes</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-als-barris/">La salut als barris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-a-les-abs/">La salut a les ABS</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/sistema-dinformacio-de-lesions-pel-transit/">Lesions de trànsit</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/salut-sexual-reproductiva/">Salut sexual i reproductiva</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/sistema-informacio-mortalitat/">Informació de la mortalitat</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/enquestes-de-salut/">Enquestes de salut</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/enquesta-fresc/">Enquesta Factors de Risc a l'Escola Secundària (FRESC)</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_61">Etapes de la vida</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/infancia/">Infància</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/adolescencia/">Adolescència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/adultesa/">Adultesa</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/persones-grans/">Persones grans</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/poblacions-especifiques/">Poblacions específiques</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_268">Viure amb salut</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/activitat-fisica/">Activitat física</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/alimentacio/">Alimentació</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/prevencio-de-les-addicions/">Prevenció de les addiccions</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/salut-mental/">Salut mental</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/sexualitat-i-afectivitat/">Sexualitat i afectivitat</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/vacunes/">Vacunes</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_282">Entorns</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/familia/">Família</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/barris/">Barris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/escoles/">Escoles</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/centres-de-salut/">Centres de salut</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/treball/">Treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/ciutat/">Ciutat</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_296">Epidemiologia</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/programa-de-prevencio-i-control-de-la-tuberculosi/">Tuberculosi</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-la-vihsida-its-i-hepatitis-viriques/">VIH/sida i Infeccions de Transmissió Sexual</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-control-hepatitis-viriques-malaltia-meningococcia/">Hepatitis víriques i malaltia meningocòccia</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-la-grip-i-altres-virus-respiratoris/">Grip i altres virus respiratoris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-transmeses-per-aliments/">Malalties transmeses per aliments</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-transmeses-per-vectors/">Malalties transmeses per vectors</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-prevenibles-per-vacunacio/">Malalties prevenibles per vacunació</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-de-declaracio-microbiologica/">Malalties de declaració microbiològica</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/legionelosi-i-altres-malalties-transmissibles/">Legionelosi i altres malalties transmissibles</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-brots-epidemics/">Brots epidèmics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/materials-per-a-la-notificacio-de-malalties-de-declaracio-obligatoria-i-brots/">Materials per a la notificació</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_57">Drogodependències</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/prevencio/">Prevenció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/tractament-a-adolescents-i-joves/">Tractament a adolescents i joves</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/tractament-a-adults/">Tractament a adults</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/reduccio-de-danys/">Reducció de danys</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/sistema-dinformacio-sobre-drogues-de-barcelona/">Sistema d'informació sobre drogues</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/plans-estrategics/">Plans estratègics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/centres-datencio-seguiment-barcelona/">Centres d'atenció i seguiment (CAS)</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_69">Salut ambiental</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/aigua-de-consum/">Aigua de consum</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/allotjaments-infantils-i-juvenils/">Allotjaments infantils i juvenils</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/qualitat-de-laire/">Qualitat de l'aire</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/legionela/">Instal·lacions amb risc de dispersió de la Legionel·la</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/platges/">Platges</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/piscines-dus-public/">Piscines d’ús públic</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/establiments-i-serveis-plaguicides/">Establiments i serveis plaguicides</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/informacio-sobre-altres-riscos-ambientals/">Informació sobre altres riscos ambientals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/tatuatges-pircings-i-micropigmentacio/">Tatuatges, pírcings i micropigmentació</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_65">Seguretat alimentària</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/la-inspeccio-sanitaria/">La inspecció sanitària</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/condicions-sanitaries-dels-establiments-i-productes-alimentaris/">Condicions sanitàries dels establiments i productes alimentaris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/autocontrols-dels-establiments-i-activitats-alimentaries/">Autocontrol dels establiments i activitats alimentàries</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/programes-de-vigilancia-sanitaria-daliments/">Vigilància sanitària d’aliments</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/autoritzacions-i-registre-destabliments-alimentaris/">Autoritzacions i registre d’establiments alimentaris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/certificats-sanitaris/">Certificats sanitaris per a empreses inscrites a l'RSIPAC</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/denuncies-alertes-i-toxiinfeccions-alimentaries/">Denúncies, alertes i toxiinfeccions alimentàries</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_71">Plagues urbanes</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/vigilancia-i-control-de-plagues-ambientals/">Vigilància i control de plagues ambientals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/vigilancia-aus-salvatges-urbanes/">Vigilància d’aus salvatges urbanes</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/com-informar-duna-plaga-igual-a-incidencies-o-atencio-ciutadana/">Com informar d’una plaga</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/especies-problematiques-i-recomanacions/">Espècies problemàtiques i recomanacions</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_67">Salut i treball</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/sistema-de-vigilancia-de-malalties-relacionades-amb-el-treball/">Sistema de vigilància de malalties relacionades amb el treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/programa-de-vigilancia-post-ocupacional-de-lexposicio-a-lamiant/">Programa de vigilància post-ocupacional de l’exposició a l’amiant</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/materials-notificacio-malalties-relacionades-treball/">Materials per a la notificació de malalties relacionades amb el treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/recursos-en-salut-laboral/">Recursos en salut i prevenció de riscos laborals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/sistema-dinformacio-en-salut-laboral/">Sistema d’informació en salut laboral</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/entorn-psicosocial-del-treball/">Entorn psicosocial del treball</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_59">Laboratori</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/cartera-de-serveis-analitics/">Serveis analítics i preus públics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/certificats-i-reconeixements/">Acreditació ENAC i altres reconeixements</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/contacte-laboratori/">Àrea clients</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/notes-informatives/">Notes informatives</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_73">Recerca i docència</a><ul>
							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/estrategia-de-recerca-i-docencia/">Estratègia de recerca i docència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/arees-grups-de-recerca/">Àrees i grups de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/projectes-de-recerca/">Projectes de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/sessions-cientifiques/">Sessions científiques</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/docencia/">Docència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/beques-recerca/">Beques de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul></li>
														<li><a href="javascript://" class="link_children" data-id="nav_biblioteca">Biblioteca</a><ul><li>
							<div class="formulari">
								<div class="camp">
									<label>Cercar per àrea</label>
									<div class="select_wrapper">
										<select class="tema">
											<option value="*" data-slug="*" selected="selected">Totes</option>
																							<option data-id="219" data-slug="barris-2" value="219">Barris</option>
																							<option data-id="3" data-slug="drogodependencies" value="3">Drogodependències</option>
																							<option data-id="88" data-slug="promocio-entorns" value="88">Entorns</option>
																							<option data-id="95" data-slug="vigilancia-epidemiologica" value="95">Epidemiologia</option>
																							<option data-id="75" data-slug="promocio-etapes-de-la-vida" value="75">Etapes de la vida</option>
																							<option data-id="65" data-slug="la-salut-en-xifres" value="65">La Salut en xifres</option>
																							<option data-id="4" data-slug="laboratori" value="4">Laboratori</option>
																							<option data-id="11" data-slug="plagues-urbanes" value="11">Plagues urbanes</option>
																							<option data-id="7" data-slug="recerca-i-docencia" value="7">Recerca i docència</option>
																							<option data-id="10" data-slug="salut-ambiental" value="10">Salut ambiental</option>
																							<option data-id="5" data-slug="salut-i-treball" value="5">Salut i treball</option>
																							<option data-id="9" data-slug="seguretat-alimentaria" value="9">Seguretat alimentària</option>
																							<option data-id="81" data-slug="promocio-viure-amb-salut" value="81">Viure amb salut</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Cercar per subàrea</label>
									<div class="select_wrapper">
										<select class="subtema">
											<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																							<option class="tema_10" data-id="110" value="aigua-de-consum" disabled="disabled" style="display: none;">Aigua de consum</option>
																							<option class="tema_10" data-id="111" value="allotjaments-infantils-i-juvenils" disabled="disabled" style="display: none;">Allotjaments infantils i juvenils</option>
																							<option class="tema_10" data-id="206" value="informacio-sobre-altres-riscos-ambientals" disabled="disabled" style="display: none;">Informació sobre altres riscos ambientals</option>
																							<option class="tema_10" data-id="113" value="legionel%c2%b7la" disabled="disabled" style="display: none;">Legionel·la</option>
																							<option class="tema_10" data-id="114" value="platges" disabled="disabled" style="display: none;">Platges</option>
																							<option class="tema_10" data-id="112" value="qualitat-de-laire" disabled="disabled" style="display: none;">Qualitat de l'aire</option>
																							<option class="tema_10" data-id="117" value="tatuatges-pircings-i-micropigmentacio" disabled="disabled" style="display: none;">Tatuatges, pírcings i micropigmentació</option>
																							<option class="tema_11" data-id="126" value="especies-problematiques-i-recomanacions" disabled="disabled" style="display: none;">Espècies problemàtiques i recomanacions</option>
																							<option class="tema_11" data-id="124" value="vigilancia-aus-salvatges-urbanes" disabled="disabled" style="display: none;">Vigilància d’aus salvatges urbanes</option>
																							<option class="tema_11" data-id="123" value="vigilancia-i-control-de-plagues-ambientals" disabled="disabled" style="display: none;">Vigilància i control de plagues ambientals</option>
																							<option class="tema_219" data-id="254" value="el-besos-i-el-maresme" disabled="disabled" style="display: none;">El Besòs i el Maresme</option>
																							<option class="tema_219" data-id="249" value="el-bon-pastor" disabled="disabled" style="display: none;">El Bon Pastor</option>
																							<option class="tema_219" data-id="244" value="el-gotic" disabled="disabled" style="display: none;">El Gòtic</option>
																							<option class="tema_219" data-id="245" value="el-poble-sec" disabled="disabled" style="display: none;">El Poble-sec</option>
																							<option class="tema_219" data-id="258" value="putxet-farro" disabled="disabled" style="display: none;">El Putxet i el Farró</option>
																							<option class="tema_219" data-id="255" value="el-raval" disabled="disabled" style="display: none;">El Raval</option>
																							<option class="tema_219" data-id="260" value="horta-guinardo" disabled="disabled" style="display: none;">Horta-Guinardó</option>
																							<option class="tema_219" data-id="257" value="la-barceloneta" disabled="disabled" style="display: none;">La Barceloneta</option>
																							<option class="tema_219" data-id="248" value="la-marina-del-prat-vermell" disabled="disabled" style="display: none;">La Marina del Prat Vermell</option>
																							<option class="tema_219" data-id="246" value="la-teixonera" disabled="disabled" style="display: none;">La Teixonera</option>
																							<option class="tema_219" data-id="252" value="la-trinitat-nova" disabled="disabled" style="display: none;">La Trinitat Nova</option>
																							<option class="tema_219" data-id="250" value="la-trinitat-vella" disabled="disabled" style="display: none;">La Trinitat Vella</option>
																							<option class="tema_219" data-id="220" value="la-verneda-i-la-pau" disabled="disabled" style="display: none;">La Verneda i la Pau</option>
																							<option class="tema_219" data-id="221" value="nou-barris" disabled="disabled" style="display: none;">Nou Barris</option>
																							<option class="tema_219" data-id="247" value="sant-genis-dels-agudells" disabled="disabled" style="display: none;">Sant Genís dels Agudells</option>
																							<option class="tema_219" data-id="259" value="sant-gervasi-la-bonanova" disabled="disabled" style="display: none;">Sant Gervasi - la Bonanova</option>
																							<option class="tema_219" data-id="251" value="verdun" disabled="disabled" style="display: none;">Verdun</option>
																							<option class="tema_3" data-id="205" value="centres-datencio-i-seguiment-cas" disabled="disabled" style="display: none;">Centres d’atenció i seguiment (CAS)</option>
																							<option class="tema_3" data-id="109" value="plans-estrategics" disabled="disabled" style="display: none;">Plans estratègics</option>
																							<option class="tema_3" data-id="106" value="prevencio" disabled="disabled" style="display: none;">Prevenció</option>
																							<option class="tema_3" data-id="108" value="reduccio-de-danys" disabled="disabled" style="display: none;">Reducció de danys</option>
																							<option class="tema_3" data-id="105" value="sistema-dinformacio-sobre-drogues-de-barcelona" disabled="disabled" style="display: none;">Sistema d'informació sobre drogues de Barcelona</option>
																							<option class="tema_3" data-id="107" value="tractament-a-adults" disabled="disabled" style="display: none;">Tractament a adults</option>
																							<option class="tema_3" data-id="64" value="tractament-a-joves" disabled="disabled" style="display: none;">Tractament a joves</option>
																							<option class="tema_4" data-id="136" value="el-laboratori-informa" disabled="disabled" style="display: none;">El Laboratori informa</option>
																							<option class="tema_4" data-id="135" value="contacte-laboratori" disabled="disabled" style="display: none;">Àrea clients</option>
																							<option class="tema_5" data-id="129" value="entorn-psicosocial-del-treball" disabled="disabled" style="display: none;">Entorn psicosocial del treball</option>
																							<option class="tema_5" data-id="214" value="materials-per-a-la-notificacio-de-malalties-relacionades-amb-el-treball" disabled="disabled" style="display: none;">Materials per a la notificació de malalties relacionades amb el treball</option>
																							<option class="tema_5" data-id="128" value="programa-de-vigilancia-post-ocupacional-de-lexposicio-a-lamiant" disabled="disabled" style="display: none;">Programa de vigilància post-ocupacional de l’exposició a l’amiant</option>
																							<option class="tema_5" data-id="132" value="recursos-en-salut-laboral" disabled="disabled" style="display: none;">Recursos en salut i prevenció de riscos laborals</option>
																							<option class="tema_5" data-id="127" value="sistema-de-vigilancia-de-malalties-relacionades-amb-el-treball" disabled="disabled" style="display: none;">Sistema de vigilància de malalties relacionades amb el treball</option>
																							<option class="tema_5" data-id="131" value="sistema-dinformacio-en-salut-laboral" disabled="disabled" style="display: none;">Sistema d’informació en salut laboral</option>
																							<option class="tema_65" data-id="74" value="enquesta-fresc" disabled="disabled" style="display: none;">Enquesta Factors de Risc a l'Escola Secundària (FRESC)</option>
																							<option class="tema_65" data-id="73" value="enquestes-de-salut" disabled="disabled" style="display: none;">Enquestes de salut</option>
																							<option class="tema_65" data-id="72" value="sistema-dinformacio-de-la-mortalitat" disabled="disabled" style="display: none;">Informació de la mortalitat</option>
																							<option class="tema_65" data-id="66" value="la-salut-a-barcelona" disabled="disabled" style="display: none;">La salut a Barcelona</option>
																							<option class="tema_65" data-id="69" value="la-salut-a-les-abs" disabled="disabled" style="display: none;">La salut a les ABS</option>
																							<option class="tema_65" data-id="68" value="la-salut-als-barris" disabled="disabled" style="display: none;">La salut als barris</option>
																							<option class="tema_65" data-id="67" value="la-salut-als-districtes" disabled="disabled" style="display: none;">La salut als districtes</option>
																							<option class="tema_65" data-id="70" value="sistema-dinformacio-de-lesions-pel-transit" disabled="disabled" style="display: none;">Lesions pel trànsit</option>
																							<option class="tema_65" data-id="71" value="sistema-dinformacio-de-la-salut-sexual-i-reproductiva" disabled="disabled" style="display: none;">Salut sexual i reproductiva</option>
																							<option class="tema_75" data-id="77" value="adolescencia" disabled="disabled" style="display: none;">Adolescència</option>
																							<option class="tema_75" data-id="78" value="adultesa" disabled="disabled" style="display: none;">Adultesa</option>
																							<option class="tema_75" data-id="79" value="gent-gran" disabled="disabled" style="display: none;">Gent gran</option>
																							<option class="tema_75" data-id="76" value="infancia" disabled="disabled" style="display: none;">Infància</option>
																							<option class="tema_75" data-id="80" value="poblacions-especifiques" disabled="disabled" style="display: none;">Poblacions especifiques</option>
																							<option class="tema_7" data-id="137" value="estrategia-de-recerca-i-docencia" disabled="disabled" style="display: none;">Estratègia de recerca i docència</option>
																							<option class="tema_7" data-id="139" value="projectes-de-recerca" disabled="disabled" style="display: none;">Projectes de recerca</option>
																							<option class="tema_7" data-id="142" value="sessions-cientifiques" disabled="disabled" style="display: none;">Sessions científiques</option>
																							<option class="tema_81" data-id="82" value="activitat-fisica" disabled="disabled" style="display: none;">Activitat física</option>
																							<option class="tema_81" data-id="83" value="alimentacio" disabled="disabled" style="display: none;">Alimentació</option>
																							<option class="tema_81" data-id="84" value="prevencio-de-les-addicions" disabled="disabled" style="display: none;">Prevenció de les addiccions</option>
																							<option class="tema_81" data-id="85" value="salut-mental" disabled="disabled" style="display: none;">Salut mental</option>
																							<option class="tema_81" data-id="86" value="sexualitat-i-afectivitat" disabled="disabled" style="display: none;">Sexualitat i afectivitat</option>
																							<option class="tema_81" data-id="87" value="vacunes" disabled="disabled" style="display: none;">Vacunes</option>
																							<option class="tema_88" data-id="90" value="barris" disabled="disabled" style="display: none;">Barris</option>
																							<option class="tema_88" data-id="94" value="ciutat" disabled="disabled" style="display: none;">Ciutat</option>
																							<option class="tema_88" data-id="91" value="escoles" disabled="disabled" style="display: none;">Escoles</option>
																							<option class="tema_88" data-id="89" value="familia" disabled="disabled" style="display: none;">Família</option>
																							<option class="tema_88" data-id="93" value="treball" disabled="disabled" style="display: none;">Treball</option>
																							<option class="tema_95" data-id="218" value="legionelosi-i-altres-malalties-transmissibles" disabled="disabled" style="display: none;">Legionelosi i altres malalties transmissibles</option>
																							<option class="tema_95" data-id="104" value="materials-per-a-la-notificacio-de-malalties-de-declaracio-obligatoria-i-brots" disabled="disabled" style="display: none;">Materials per a la notificació de malalties de declaració obligatòria i brots</option>
																							<option class="tema_95" data-id="96" value="programa-de-prevencio-i-control-de-la-tuberculosi" disabled="disabled" style="display: none;">Programa de prevenció i control de la tuberculosi</option>
																							<option class="tema_95" data-id="102" value="vigilancia-i-control-daltres-malalties-transmissibles" disabled="disabled" style="display: none;">Vigilància i control d'altres malalties transmissibles</option>
																							<option class="tema_95" data-id="144" value="vigilancia-i-control-de-la-vihsida-its-i-hepatitis-viriques" disabled="disabled" style="display: none;">Vigilància i control de la VIH/sida, ITS i hepatitis víriques</option>
																							<option class="tema_95" data-id="97" value="vigilancia-i-control-de-la-grip-i-altres-virus-respiratoris" disabled="disabled" style="display: none;">Vigilància i control de la grip i altres virus respiratoris</option>
																							<option class="tema_95" data-id="99" value="vigilancia-i-control-de-malalties-transmeses-per-vectors" disabled="disabled" style="display: none;">Vigilància i control de malalties transmeses per vectors</option>
																							<option class="tema_95" data-id="100" value="vigilancia-i-control-de-malalties-vacunables" disabled="disabled" style="display: none;">Vigilància i control de malalties vacunables</option>
																							<option class="tema_9" data-id="119" value="autocontrols-dels-establiments-i-activitats-alimentaries" disabled="disabled" style="display: none;">Autocontrols dels establiments i activitats alimentàries</option>
																							<option class="tema_9" data-id="118" value="condicions-sanitaries-dels-establiments-i-productes-alimentaris" disabled="disabled" style="display: none;">Condicions sanitàries dels establiments i productes alimentaris</option>
																							<option class="tema_9" data-id="171" value="programes-dinspeccio-sanitaria" disabled="disabled" style="display: none;">Programes d’inspecció sanitària</option>
																							<option class="tema_9" data-id="120" value="programes-de-vigilancia-sanitaria-daliments" disabled="disabled" style="display: none;">Vigilància sanitària d’aliments</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Tipus de document</label>
									<div class="select_wrapper">
										<select class="tipus_document">
											<option value="*" selected="selected">Totes</option>
																							<option data-id="15" value="materials-divulgatius">Materials divulgatius</option>
																							<option data-id="222" value="sessions-cientifiques">Sessions científiques</option>
																							<option data-id="209" value="multimedia">Multimèdia</option>
																							<option data-id="168" value="plans-estrategics">Plans estratègics</option>
																							<option data-id="17" value="informes">Informes</option>
																							<option data-id="146" value="indicadors">Indicadors</option>
																							<option data-id="18" value="materials-de-suport-i-referencia">Materials de suport i referència</option>
																							<option data-id="211" value="butlletins">Butlletins</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Any d'edició</label>
									<div class="select_wrapper">
										<select class="anyo">
											<option value="*" selected="selected">Totes</option>
																						<option value="2019">2019</option>
																						<option value="2018">2018</option>
																						<option value="2017">2017</option>
																						<option value="2016">2016</option>
																						<option value="2015">2015</option>
																						<option value="2014">2014</option>
																						<option value="2013">2013</option>
																						<option value="2012">2012</option>
																						<option value="2011">2011</option>
																						<option value="2010">2010</option>
																						<option value="2009">2009</option>
																						<option value="2008">2008</option>
																						<option value="2007">2007</option>
																						<option value="2006">2006</option>
																						<option value="2005">2005</option>
																						<option value="2004">2004</option>
																						<option value="2003">2003</option>
																						<option value="2002">2002</option>
																						<option value="2001">2001</option>
																						<option value="2000">2000</option>
																						<option value="1999">1999</option>
																						<option value="1958">1958</option>
																					</select>
									</div>
								</div>

								<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_biblioteca(this)">
							</div>
							</li></ul></li>
							<li><a href="javascript://" class="link_children" data-id="nav_tramits">Tràmits</a><ul>
							<li>
								<div class="formulari">
									<div class="camp">
										<label>Cercar per àrea</label>
										<div class="select_wrapper">
											<select class="tema">
												<option value="*" data-slug="*" selected="selected">Totes</option>
																									<option data-id="10" data-slug="salut-ambiental" value="10">Salut ambiental</option>
																									<option data-id="9" data-slug="seguretat-alimentaria" value="9">Seguretat alimentària</option>
																							</select>
										</div>
									</div>

									<div class="camp">
										<label>Cercar per subàrea</label>
										<div class="select_wrapper">
											<select class="subtema">
												<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																									<option class="tema_9" data-id="171" value="programes-dinspeccio-sanitaria" disabled="disabled" style="display: none;">Programes d’inspecció sanitària</option>
																									<option class="tema_9" data-id="173" value="autoritzacions-i-registre-destabliments-alimentaris" disabled="disabled" style="display: none;">Autoritzacions i registre d’establiments alimentaris</option>
																									<option class="tema_9" data-id="174" value="certificats-sanitaris-per-a-lexportacio-daliments" disabled="disabled" style="display: none;">Certificats sanitaris per a l’exportació d’aliments</option>
																									<option class="tema_10" data-id="110" value="aigua-de-consum" disabled="disabled" style="display: none;">Aigua de consum</option>
																									<option class="tema_9" data-id="118" value="condicions-sanitaries-dels-establiments-i-productes-alimentaris" disabled="disabled" style="display: none;">Condicions sanitàries dels establiments i productes alimentaris</option>
																									<option class="tema_10" data-id="111" value="allotjaments-infantils-i-juvenils" disabled="disabled" style="display: none;">Allotjaments infantils i juvenils</option>
																									<option class="tema_9" data-id="119" value="autocontrols-dels-establiments-i-activitats-alimentaries" disabled="disabled" style="display: none;">Autocontrols dels establiments i activitats alimentàries</option>
																									<option class="tema_10" data-id="113" value="legionel%c2%b7la" disabled="disabled" style="display: none;">Legionel·la</option>
																									<option class="tema_9" data-id="122" value="denuncies-alertes-i-toxiinfeccions-alimentaries" disabled="disabled" style="display: none;">Denúncies, alertes i toxiinfeccions alimentàries</option>
																									<option class="tema_10" data-id="115" value="piscines" disabled="disabled" style="display: none;">Piscines</option>
																									<option class="tema_10" data-id="116" value="establiments-i-serveis-plaguicides" disabled="disabled" style="display: none;">Establiments i serveis plaguicides</option>
																									<option class="tema_10" data-id="117" value="tatuatges-pircings-i-micropigmentacio" disabled="disabled" style="display: none;">Tatuatges, pírcings i micropigmentació</option>
																							</select>
										</div>
									</div>

									<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_tramits()">
								</div>
							</li>
						</ul></li>

															<li><a href="javascript://" class="link_children link_to_programas" data-id="nav_programes">Programes</a><ul><li>
							<div class="formulari">
								<div class="camp">
									<label>Cercar per àrea</label>
									<div class="select_wrapper">
										<select class="tema">
											<option value="*" data-slug="*" selected="selected">Totes</option>
																							<option data-id="75" data-slug="promocio-etapes-de-la-vida" value="75">Etapes de la vida</option>
																							<option data-id="81" data-slug="promocio-viure-amb-salut" value="81">Viure amb salut</option>
																							<option data-id="88" data-slug="promocio-entorns" value="88">Entorns</option>
																							<option data-id="3" data-slug="drogodependencies" value="3">Drogodependències</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Cercar per subàrea</label>
									<div class="select_wrapper">
										<select class="subtema">
											<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																							<option class="tema_75" data-id="77" value="adolescencia" disabled="disabled" style="display: none;">Adolescència</option>
																							<option class="tema_3" data-id="106" value="prevencio" disabled="disabled" style="display: none;">Prevenció</option>
																							<option class="tema_81" data-id="84" value="prevencio-de-les-addicions" disabled="disabled" style="display: none;">Prevenció de les addiccions</option>
																							<option class="tema_88" data-id="91" value="escoles" disabled="disabled" style="display: none;">Escoles</option>
																							<option class="tema_81" data-id="83" value="alimentacio" disabled="disabled" style="display: none;">Alimentació</option>
																							<option class="tema_81" data-id="86" value="sexualitat-i-afectivitat" disabled="disabled" style="display: none;">Sexualitat i afectivitat</option>
																							<option class="tema_75" data-id="76" value="infancia" disabled="disabled" style="display: none;">Infància</option>
																							<option class="tema_81" data-id="82" value="activitat-fisica" disabled="disabled" style="display: none;">Activitat física</option>
																							<option class="tema_88" data-id="89" value="familia" disabled="disabled" style="display: none;">Família</option>
																							<option class="tema_88" data-id="90" value="barris" disabled="disabled" style="display: none;">Barris</option>
																							<option class="tema_75" data-id="79" value="gent-gran" disabled="disabled" style="display: none;">Gent gran</option>
																							<option class="tema_75" data-id="80" value="poblacions-especifiques" disabled="disabled" style="display: none;">Poblacions especifiques</option>
																							<option class="tema_75" data-id="78" value="adultesa" disabled="disabled" style="display: none;">Adultesa</option>
																					</select>
									</div>
								</div>

								<input type="hidden" name="anyo" value="*">

								
								<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_programa(this)">
							</div>
							</li></ul></li>
							
							<li class="cercar"><a href="javascript://" class="link_children" data-id="nav_cercar">Cercar</a><form role="search" method="get" id="searchform" class="searchform" action="https://www.aspb.cat/">
				<div>
					<label class="screen-reader-text" for="s">Cerca:</label>
					<input type="text" name="s" id="s">
					<input type="submit" id="searchsubmit" value="Cerca">
				</div>
			</form></li>
						</ul>
					</nav>
										<nav id="nav_22" class="primer_nivel">

						

						<ul>
							
												<li><a href="https://www.aspb.cat/l-agencia/qui-som/">Qui som</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/on-som/">On som</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/qualitat/">Gestió de serveis</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_28">Portal de transparència</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/comunicacio-i-imatge/">Imatge corporativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/treballar-aspb/">Treballar a l'ASPB</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/proveidors/">Proveïdors i perfil del contractant</a></li>

							
												<li><a href="https://www.aspb.cat/noticies/">Notícies</a></li>

							
												<li><a href="https://www.aspb.cat/agenda">Activitats</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/premsa/">Premsa</a></li>

													</ul>
					</nav>
					<nav id="nav_28" data-parent_id="nav_22" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Portal de transparència</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/informacio-institucional-organitzativa/">Informació institucional i organitzativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/plans-i-objectius/">Plans i objectius</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/documents-de-referencia/">Documents de referència</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/gestio-economica-administrativa/">Gestió econòmica i administrativa</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/participacio-relacio-ciutadania/">Participació i relació amb la ciutadania</a></li>

							
												<li><a href="https://www.aspb.cat/l-agencia/portal-de-transparencia/dret-dacces-informacio-publica/">Dret d’accés a la informació pública</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_53" class="primer_nivel">

						

						<ul>
																			<li><a href="javascript://" class="link_children" data-id="nav_55">La Salut en xifres</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_61">Etapes de la vida</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_268">Viure amb salut</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_282">Entorns</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_296">Epidemiologia</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_57">Drogodependències</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_69">Salut ambiental</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_65">Seguretat alimentària</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_71">Plagues urbanes</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_67">Salut i treball</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_59">Laboratori</a></li>

																			<li><a href="javascript://" class="link_children" data-id="nav_73">Recerca i docència</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_55" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">La Salut en xifres</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/salut-barcelona/">La salut a Barcelona</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-als-districtes/">La salut als districtes</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-als-barris/">La salut als barris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-a-les-abs/">La salut a les ABS</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/sistema-dinformacio-de-lesions-pel-transit/">Lesions de trànsit</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/salut-sexual-reproductiva/">Salut sexual i reproductiva</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/sistema-informacio-mortalitat/">Informació de la mortalitat</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/enquestes-de-salut/">Enquestes de salut</a></li>

							
												<li><a href="https://www.aspb.cat/arees/la-salut-en-xifres/enquesta-fresc/">Enquesta Factors de Risc a l'Escola Secundària (FRESC)</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_61" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Etapes de la vida</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/infancia/">Infància</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/adolescencia/">Adolescència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/adultesa/">Adultesa</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/persones-grans/">Persones grans</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-etapes-de-la-vida/poblacions-especifiques/">Poblacions específiques</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_268" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Viure amb salut</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/activitat-fisica/">Activitat física</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/alimentacio/">Alimentació</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/prevencio-de-les-addicions/">Prevenció de les addiccions</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/salut-mental/">Salut mental</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/sexualitat-i-afectivitat/">Sexualitat i afectivitat</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-viure-amb-salut/vacunes/">Vacunes</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul>
					</nav>
					<nav id="nav_282" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Entorns</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/familia/">Família</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/barris/">Barris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/escoles/">Escoles</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/centres-de-salut/">Centres de salut</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/treball/">Treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/promocio-entorns/ciutat/">Ciutat</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul>
					</nav>
					<nav id="nav_296" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Epidemiologia</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/programa-de-prevencio-i-control-de-la-tuberculosi/">Tuberculosi</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-la-vihsida-its-i-hepatitis-viriques/">VIH/sida i Infeccions de Transmissió Sexual</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-control-hepatitis-viriques-malaltia-meningococcia/">Hepatitis víriques i malaltia meningocòccia</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-la-grip-i-altres-virus-respiratoris/">Grip i altres virus respiratoris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-transmeses-per-aliments/">Malalties transmeses per aliments</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-transmeses-per-vectors/">Malalties transmeses per vectors</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-prevenibles-per-vacunacio/">Malalties prevenibles per vacunació</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-malalties-de-declaracio-microbiologica/">Malalties de declaració microbiològica</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/legionelosi-i-altres-malalties-transmissibles/">Legionelosi i altres malalties transmissibles</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/vigilancia-i-control-de-brots-epidemics/">Brots epidèmics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/epidemiologia/materials-per-a-la-notificacio-de-malalties-de-declaracio-obligatoria-i-brots/">Materials per a la notificació</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_57" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Drogodependències</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/prevencio/">Prevenció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/tractament-a-adolescents-i-joves/">Tractament a adolescents i joves</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/tractament-a-adults/">Tractament a adults</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/reduccio-de-danys/">Reducció de danys</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/sistema-dinformacio-sobre-drogues-de-barcelona/">Sistema d'informació sobre drogues</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/plans-estrategics/">Plans estratègics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/drogodependencies/centres-datencio-seguiment-barcelona/">Centres d'atenció i seguiment (CAS)</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_69" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Salut ambiental</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/aigua-de-consum/">Aigua de consum</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/allotjaments-infantils-i-juvenils/">Allotjaments infantils i juvenils</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/qualitat-de-laire/">Qualitat de l'aire</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/legionela/">Instal·lacions amb risc de dispersió de la Legionel·la</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/platges/">Platges</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/piscines-dus-public/">Piscines d’ús públic</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/establiments-i-serveis-plaguicides/">Establiments i serveis plaguicides</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/informacio-sobre-altres-riscos-ambientals/">Informació sobre altres riscos ambientals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-ambiental/tatuatges-pircings-i-micropigmentacio/">Tatuatges, pírcings i micropigmentació</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_65" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Seguretat alimentària</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/la-inspeccio-sanitaria/">La inspecció sanitària</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/condicions-sanitaries-dels-establiments-i-productes-alimentaris/">Condicions sanitàries dels establiments i productes alimentaris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/autocontrols-dels-establiments-i-activitats-alimentaries/">Autocontrol dels establiments i activitats alimentàries</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/programes-de-vigilancia-sanitaria-daliments/">Vigilància sanitària d’aliments</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/autoritzacions-i-registre-destabliments-alimentaris/">Autoritzacions i registre d’establiments alimentaris</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/certificats-sanitaris/">Certificats sanitaris per a empreses inscrites a l'RSIPAC</a></li>

							
												<li><a href="https://www.aspb.cat/arees/seguretat-alimentaria/denuncies-alertes-i-toxiinfeccions-alimentaries/">Denúncies, alertes i toxiinfeccions alimentàries</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_71" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Plagues urbanes</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/vigilancia-i-control-de-plagues-ambientals/">Vigilància i control de plagues ambientals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/vigilancia-aus-salvatges-urbanes/">Vigilància d’aus salvatges urbanes</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/com-informar-duna-plaga-igual-a-incidencies-o-atencio-ciutadana/">Com informar d’una plaga</a></li>

							
												<li><a href="https://www.aspb.cat/arees/plagues-urbanes/especies-problematiques-i-recomanacions/">Espècies problemàtiques i recomanacions</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_67" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Salut i treball</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/sistema-de-vigilancia-de-malalties-relacionades-amb-el-treball/">Sistema de vigilància de malalties relacionades amb el treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/programa-de-vigilancia-post-ocupacional-de-lexposicio-a-lamiant/">Programa de vigilància post-ocupacional de l’exposició a l’amiant</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/materials-notificacio-malalties-relacionades-treball/">Materials per a la notificació de malalties relacionades amb el treball</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/recursos-en-salut-laboral/">Recursos en salut i prevenció de riscos laborals</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/sistema-dinformacio-en-salut-laboral/">Sistema d’informació en salut laboral</a></li>

							
												<li><a href="https://www.aspb.cat/arees/salut-i-treball/entorn-psicosocial-del-treball/">Entorn psicosocial del treball</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul>
					</nav>
					<nav id="nav_59" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Laboratori</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/cartera-de-serveis-analitics/">Serveis analítics i preus públics</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/certificats-i-reconeixements/">Acreditació ENAC i altres reconeixements</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/contacte-laboratori/">Àrea clients</a></li>

							
												<li><a href="https://www.aspb.cat/arees/el-laboratori/notes-informatives/">Notes informatives</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

							<li class="extra_column"><a href="javascript://"></a></li><li class="extra_column"><a href="javascript://"></a></li>						</ul>
					</nav>
					<nav id="nav_73" data-parent_id="nav_53" class="no_primer_nivel">

													<div class="header_menu">

								<a href="javascript://" class="tornar titol">Recerca i docència</a>
								<a href="javascript://" class="tornar link">Tornar</a>

							</div>
						

						<ul>
							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/introduccio/">Introducció</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/estrategia-de-recerca-i-docencia/">Estratègia de recerca i docència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/arees-grups-de-recerca/">Àrees i grups de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/projectes-de-recerca/">Projectes de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/sessions-cientifiques/">Sessions científiques</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/docencia/">Docència</a></li>

							
												<li><a href="https://www.aspb.cat/arees/recerca-i-docencia/beques-recerca/">Beques de recerca</a></li>

							
												<li><a href="https://www.aspb.cat/contacte/">Contacte</a></li>

													</ul>
					</nav>
					<nav id="nav_biblioteca" class="no_primer_nivel" data-archive_url="https://www.aspb.cat/documents/">
						<ul><li>
							<div class="formulari">
								<div class="camp">
									<label>Cercar per àrea</label>
									<div class="select_wrapper">
										<select class="tema">
											<option value="*" data-slug="*" selected="selected">Totes</option>
																							<option data-id="219" data-slug="barris-2" value="219">Barris</option>
																							<option data-id="3" data-slug="drogodependencies" value="3">Drogodependències</option>
																							<option data-id="88" data-slug="promocio-entorns" value="88">Entorns</option>
																							<option data-id="95" data-slug="vigilancia-epidemiologica" value="95">Epidemiologia</option>
																							<option data-id="75" data-slug="promocio-etapes-de-la-vida" value="75">Etapes de la vida</option>
																							<option data-id="65" data-slug="la-salut-en-xifres" value="65">La Salut en xifres</option>
																							<option data-id="4" data-slug="laboratori" value="4">Laboratori</option>
																							<option data-id="11" data-slug="plagues-urbanes" value="11">Plagues urbanes</option>
																							<option data-id="7" data-slug="recerca-i-docencia" value="7">Recerca i docència</option>
																							<option data-id="10" data-slug="salut-ambiental" value="10">Salut ambiental</option>
																							<option data-id="5" data-slug="salut-i-treball" value="5">Salut i treball</option>
																							<option data-id="9" data-slug="seguretat-alimentaria" value="9">Seguretat alimentària</option>
																							<option data-id="81" data-slug="promocio-viure-amb-salut" value="81">Viure amb salut</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Cercar per subàrea</label>
									<div class="select_wrapper">
										<select class="subtema">
											<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																							<option class="tema_10" data-id="110" value="aigua-de-consum" disabled="disabled" style="display: none;">Aigua de consum</option>
																							<option class="tema_10" data-id="111" value="allotjaments-infantils-i-juvenils" disabled="disabled" style="display: none;">Allotjaments infantils i juvenils</option>
																							<option class="tema_10" data-id="206" value="informacio-sobre-altres-riscos-ambientals" disabled="disabled" style="display: none;">Informació sobre altres riscos ambientals</option>
																							<option class="tema_10" data-id="113" value="legionel%c2%b7la" disabled="disabled" style="display: none;">Legionel·la</option>
																							<option class="tema_10" data-id="114" value="platges" disabled="disabled" style="display: none;">Platges</option>
																							<option class="tema_10" data-id="112" value="qualitat-de-laire" disabled="disabled" style="display: none;">Qualitat de l'aire</option>
																							<option class="tema_10" data-id="117" value="tatuatges-pircings-i-micropigmentacio" disabled="disabled" style="display: none;">Tatuatges, pírcings i micropigmentació</option>
																							<option class="tema_11" data-id="126" value="especies-problematiques-i-recomanacions" disabled="disabled" style="display: none;">Espècies problemàtiques i recomanacions</option>
																							<option class="tema_11" data-id="124" value="vigilancia-aus-salvatges-urbanes" disabled="disabled" style="display: none;">Vigilància d’aus salvatges urbanes</option>
																							<option class="tema_11" data-id="123" value="vigilancia-i-control-de-plagues-ambientals" disabled="disabled" style="display: none;">Vigilància i control de plagues ambientals</option>
																							<option class="tema_219" data-id="254" value="el-besos-i-el-maresme" disabled="disabled" style="display: none;">El Besòs i el Maresme</option>
																							<option class="tema_219" data-id="249" value="el-bon-pastor" disabled="disabled" style="display: none;">El Bon Pastor</option>
																							<option class="tema_219" data-id="244" value="el-gotic" disabled="disabled" style="display: none;">El Gòtic</option>
																							<option class="tema_219" data-id="245" value="el-poble-sec" disabled="disabled" style="display: none;">El Poble-sec</option>
																							<option class="tema_219" data-id="258" value="putxet-farro" disabled="disabled" style="display: none;">El Putxet i el Farró</option>
																							<option class="tema_219" data-id="255" value="el-raval" disabled="disabled" style="display: none;">El Raval</option>
																							<option class="tema_219" data-id="260" value="horta-guinardo" disabled="disabled" style="display: none;">Horta-Guinardó</option>
																							<option class="tema_219" data-id="257" value="la-barceloneta" disabled="disabled" style="display: none;">La Barceloneta</option>
																							<option class="tema_219" data-id="248" value="la-marina-del-prat-vermell" disabled="disabled" style="display: none;">La Marina del Prat Vermell</option>
																							<option class="tema_219" data-id="246" value="la-teixonera" disabled="disabled" style="display: none;">La Teixonera</option>
																							<option class="tema_219" data-id="252" value="la-trinitat-nova" disabled="disabled" style="display: none;">La Trinitat Nova</option>
																							<option class="tema_219" data-id="250" value="la-trinitat-vella" disabled="disabled" style="display: none;">La Trinitat Vella</option>
																							<option class="tema_219" data-id="220" value="la-verneda-i-la-pau" disabled="disabled" style="display: none;">La Verneda i la Pau</option>
																							<option class="tema_219" data-id="221" value="nou-barris" disabled="disabled" style="display: none;">Nou Barris</option>
																							<option class="tema_219" data-id="247" value="sant-genis-dels-agudells" disabled="disabled" style="display: none;">Sant Genís dels Agudells</option>
																							<option class="tema_219" data-id="259" value="sant-gervasi-la-bonanova" disabled="disabled" style="display: none;">Sant Gervasi - la Bonanova</option>
																							<option class="tema_219" data-id="251" value="verdun" disabled="disabled" style="display: none;">Verdun</option>
																							<option class="tema_3" data-id="205" value="centres-datencio-i-seguiment-cas" disabled="disabled" style="display: none;">Centres d’atenció i seguiment (CAS)</option>
																							<option class="tema_3" data-id="109" value="plans-estrategics" disabled="disabled" style="display: none;">Plans estratègics</option>
																							<option class="tema_3" data-id="106" value="prevencio" disabled="disabled" style="display: none;">Prevenció</option>
																							<option class="tema_3" data-id="108" value="reduccio-de-danys" disabled="disabled" style="display: none;">Reducció de danys</option>
																							<option class="tema_3" data-id="105" value="sistema-dinformacio-sobre-drogues-de-barcelona" disabled="disabled" style="display: none;">Sistema d'informació sobre drogues de Barcelona</option>
																							<option class="tema_3" data-id="107" value="tractament-a-adults" disabled="disabled" style="display: none;">Tractament a adults</option>
																							<option class="tema_3" data-id="64" value="tractament-a-joves" disabled="disabled" style="display: none;">Tractament a joves</option>
																							<option class="tema_4" data-id="136" value="el-laboratori-informa" disabled="disabled" style="display: none;">El Laboratori informa</option>
																							<option class="tema_4" data-id="135" value="contacte-laboratori" disabled="disabled" style="display: none;">Àrea clients</option>
																							<option class="tema_5" data-id="129" value="entorn-psicosocial-del-treball" disabled="disabled" style="display: none;">Entorn psicosocial del treball</option>
																							<option class="tema_5" data-id="214" value="materials-per-a-la-notificacio-de-malalties-relacionades-amb-el-treball" disabled="disabled" style="display: none;">Materials per a la notificació de malalties relacionades amb el treball</option>
																							<option class="tema_5" data-id="128" value="programa-de-vigilancia-post-ocupacional-de-lexposicio-a-lamiant" disabled="disabled" style="display: none;">Programa de vigilància post-ocupacional de l’exposició a l’amiant</option>
																							<option class="tema_5" data-id="132" value="recursos-en-salut-laboral" disabled="disabled" style="display: none;">Recursos en salut i prevenció de riscos laborals</option>
																							<option class="tema_5" data-id="127" value="sistema-de-vigilancia-de-malalties-relacionades-amb-el-treball" disabled="disabled" style="display: none;">Sistema de vigilància de malalties relacionades amb el treball</option>
																							<option class="tema_5" data-id="131" value="sistema-dinformacio-en-salut-laboral" disabled="disabled" style="display: none;">Sistema d’informació en salut laboral</option>
																							<option class="tema_65" data-id="74" value="enquesta-fresc" disabled="disabled" style="display: none;">Enquesta Factors de Risc a l'Escola Secundària (FRESC)</option>
																							<option class="tema_65" data-id="73" value="enquestes-de-salut" disabled="disabled" style="display: none;">Enquestes de salut</option>
																							<option class="tema_65" data-id="72" value="sistema-dinformacio-de-la-mortalitat" disabled="disabled" style="display: none;">Informació de la mortalitat</option>
																							<option class="tema_65" data-id="66" value="la-salut-a-barcelona" disabled="disabled" style="display: none;">La salut a Barcelona</option>
																							<option class="tema_65" data-id="69" value="la-salut-a-les-abs" disabled="disabled" style="display: none;">La salut a les ABS</option>
																							<option class="tema_65" data-id="68" value="la-salut-als-barris" disabled="disabled" style="display: none;">La salut als barris</option>
																							<option class="tema_65" data-id="67" value="la-salut-als-districtes" disabled="disabled" style="display: none;">La salut als districtes</option>
																							<option class="tema_65" data-id="70" value="sistema-dinformacio-de-lesions-pel-transit" disabled="disabled" style="display: none;">Lesions pel trànsit</option>
																							<option class="tema_65" data-id="71" value="sistema-dinformacio-de-la-salut-sexual-i-reproductiva" disabled="disabled" style="display: none;">Salut sexual i reproductiva</option>
																							<option class="tema_75" data-id="77" value="adolescencia" disabled="disabled" style="display: none;">Adolescència</option>
																							<option class="tema_75" data-id="78" value="adultesa" disabled="disabled" style="display: none;">Adultesa</option>
																							<option class="tema_75" data-id="79" value="gent-gran" disabled="disabled" style="display: none;">Gent gran</option>
																							<option class="tema_75" data-id="76" value="infancia" disabled="disabled" style="display: none;">Infància</option>
																							<option class="tema_75" data-id="80" value="poblacions-especifiques" disabled="disabled" style="display: none;">Poblacions especifiques</option>
																							<option class="tema_7" data-id="137" value="estrategia-de-recerca-i-docencia" disabled="disabled" style="display: none;">Estratègia de recerca i docència</option>
																							<option class="tema_7" data-id="139" value="projectes-de-recerca" disabled="disabled" style="display: none;">Projectes de recerca</option>
																							<option class="tema_7" data-id="142" value="sessions-cientifiques" disabled="disabled" style="display: none;">Sessions científiques</option>
																							<option class="tema_81" data-id="82" value="activitat-fisica" disabled="disabled" style="display: none;">Activitat física</option>
																							<option class="tema_81" data-id="83" value="alimentacio" disabled="disabled" style="display: none;">Alimentació</option>
																							<option class="tema_81" data-id="84" value="prevencio-de-les-addicions" disabled="disabled" style="display: none;">Prevenció de les addiccions</option>
																							<option class="tema_81" data-id="85" value="salut-mental" disabled="disabled" style="display: none;">Salut mental</option>
																							<option class="tema_81" data-id="86" value="sexualitat-i-afectivitat" disabled="disabled" style="display: none;">Sexualitat i afectivitat</option>
																							<option class="tema_81" data-id="87" value="vacunes" disabled="disabled" style="display: none;">Vacunes</option>
																							<option class="tema_88" data-id="90" value="barris" disabled="disabled" style="display: none;">Barris</option>
																							<option class="tema_88" data-id="94" value="ciutat" disabled="disabled" style="display: none;">Ciutat</option>
																							<option class="tema_88" data-id="91" value="escoles" disabled="disabled" style="display: none;">Escoles</option>
																							<option class="tema_88" data-id="89" value="familia" disabled="disabled" style="display: none;">Família</option>
																							<option class="tema_88" data-id="93" value="treball" disabled="disabled" style="display: none;">Treball</option>
																							<option class="tema_95" data-id="218" value="legionelosi-i-altres-malalties-transmissibles" disabled="disabled" style="display: none;">Legionelosi i altres malalties transmissibles</option>
																							<option class="tema_95" data-id="104" value="materials-per-a-la-notificacio-de-malalties-de-declaracio-obligatoria-i-brots" disabled="disabled" style="display: none;">Materials per a la notificació de malalties de declaració obligatòria i brots</option>
																							<option class="tema_95" data-id="96" value="programa-de-prevencio-i-control-de-la-tuberculosi" disabled="disabled" style="display: none;">Programa de prevenció i control de la tuberculosi</option>
																							<option class="tema_95" data-id="102" value="vigilancia-i-control-daltres-malalties-transmissibles" disabled="disabled" style="display: none;">Vigilància i control d'altres malalties transmissibles</option>
																							<option class="tema_95" data-id="144" value="vigilancia-i-control-de-la-vihsida-its-i-hepatitis-viriques" disabled="disabled" style="display: none;">Vigilància i control de la VIH/sida, ITS i hepatitis víriques</option>
																							<option class="tema_95" data-id="97" value="vigilancia-i-control-de-la-grip-i-altres-virus-respiratoris" disabled="disabled" style="display: none;">Vigilància i control de la grip i altres virus respiratoris</option>
																							<option class="tema_95" data-id="99" value="vigilancia-i-control-de-malalties-transmeses-per-vectors" disabled="disabled" style="display: none;">Vigilància i control de malalties transmeses per vectors</option>
																							<option class="tema_95" data-id="100" value="vigilancia-i-control-de-malalties-vacunables" disabled="disabled" style="display: none;">Vigilància i control de malalties vacunables</option>
																							<option class="tema_9" data-id="119" value="autocontrols-dels-establiments-i-activitats-alimentaries" disabled="disabled" style="display: none;">Autocontrols dels establiments i activitats alimentàries</option>
																							<option class="tema_9" data-id="118" value="condicions-sanitaries-dels-establiments-i-productes-alimentaris" disabled="disabled" style="display: none;">Condicions sanitàries dels establiments i productes alimentaris</option>
																							<option class="tema_9" data-id="171" value="programes-dinspeccio-sanitaria" disabled="disabled" style="display: none;">Programes d’inspecció sanitària</option>
																							<option class="tema_9" data-id="120" value="programes-de-vigilancia-sanitaria-daliments" disabled="disabled" style="display: none;">Vigilància sanitària d’aliments</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Tipus de document</label>
									<div class="select_wrapper">
										<select class="tipus_document">
											<option value="*" selected="selected">Totes</option>
																							<option data-id="15" value="materials-divulgatius">Materials divulgatius</option>
																							<option data-id="222" value="sessions-cientifiques">Sessions científiques</option>
																							<option data-id="209" value="multimedia">Multimèdia</option>
																							<option data-id="168" value="plans-estrategics">Plans estratègics</option>
																							<option data-id="17" value="informes">Informes</option>
																							<option data-id="146" value="indicadors">Indicadors</option>
																							<option data-id="18" value="materials-de-suport-i-referencia">Materials de suport i referència</option>
																							<option data-id="211" value="butlletins">Butlletins</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Any d'edició</label>
									<div class="select_wrapper">
										<select class="anyo">
											<option value="*" selected="selected">Totes</option>
																						<option value="2019">2019</option>
																						<option value="2018">2018</option>
																						<option value="2017">2017</option>
																						<option value="2016">2016</option>
																						<option value="2015">2015</option>
																						<option value="2014">2014</option>
																						<option value="2013">2013</option>
																						<option value="2012">2012</option>
																						<option value="2011">2011</option>
																						<option value="2010">2010</option>
																						<option value="2009">2009</option>
																						<option value="2008">2008</option>
																						<option value="2007">2007</option>
																						<option value="2006">2006</option>
																						<option value="2005">2005</option>
																						<option value="2004">2004</option>
																						<option value="2003">2003</option>
																						<option value="2002">2002</option>
																						<option value="2001">2001</option>
																						<option value="2000">2000</option>
																						<option value="1999">1999</option>
																						<option value="1958">1958</option>
																					</select>
									</div>
								</div>

								<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_biblioteca(this)">
							</div>
							</li></ul>
					</nav>

											<nav id="nav_programes" class="no_primer_nivel" data-archive_url="https://www.aspb.cat/documents/programes">
							<ul><li>
							<div class="formulari">
								<div class="camp">
									<label>Cercar per àrea</label>
									<div class="select_wrapper">
										<select class="tema">
											<option value="*" data-slug="*" selected="selected">Totes</option>
																							<option data-id="75" data-slug="promocio-etapes-de-la-vida" value="75">Etapes de la vida</option>
																							<option data-id="81" data-slug="promocio-viure-amb-salut" value="81">Viure amb salut</option>
																							<option data-id="88" data-slug="promocio-entorns" value="88">Entorns</option>
																							<option data-id="3" data-slug="drogodependencies" value="3">Drogodependències</option>
																					</select>
									</div>
								</div>

								<div class="camp">
									<label>Cercar per subàrea</label>
									<div class="select_wrapper">
										<select class="subtema">
											<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																							<option class="tema_75" data-id="77" value="adolescencia" disabled="disabled" style="display: none;">Adolescència</option>
																							<option class="tema_3" data-id="106" value="prevencio" disabled="disabled" style="display: none;">Prevenció</option>
																							<option class="tema_81" data-id="84" value="prevencio-de-les-addicions" disabled="disabled" style="display: none;">Prevenció de les addiccions</option>
																							<option class="tema_88" data-id="91" value="escoles" disabled="disabled" style="display: none;">Escoles</option>
																							<option class="tema_81" data-id="83" value="alimentacio" disabled="disabled" style="display: none;">Alimentació</option>
																							<option class="tema_81" data-id="86" value="sexualitat-i-afectivitat" disabled="disabled" style="display: none;">Sexualitat i afectivitat</option>
																							<option class="tema_75" data-id="76" value="infancia" disabled="disabled" style="display: none;">Infància</option>
																							<option class="tema_81" data-id="82" value="activitat-fisica" disabled="disabled" style="display: none;">Activitat física</option>
																							<option class="tema_88" data-id="89" value="familia" disabled="disabled" style="display: none;">Família</option>
																							<option class="tema_88" data-id="90" value="barris" disabled="disabled" style="display: none;">Barris</option>
																							<option class="tema_75" data-id="79" value="gent-gran" disabled="disabled" style="display: none;">Gent gran</option>
																							<option class="tema_75" data-id="80" value="poblacions-especifiques" disabled="disabled" style="display: none;">Poblacions especifiques</option>
																							<option class="tema_75" data-id="78" value="adultesa" disabled="disabled" style="display: none;">Adultesa</option>
																					</select>
									</div>
								</div>

								<input type="hidden" name="anyo" value="*">

								
								<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_programa(this)">
							</div>
							</li></ul>
						</nav>

					<nav id="nav_tramits" class="no_primer_nivel" data-archive_url="https://www.aspb.cat/tramits/">

						<ul>
							<li>
								<div class="formulari">
									<div class="camp">
										<label>Cercar per àrea</label>
										<div class="select_wrapper">
											<select class="tema">
												<option value="*" data-slug="*" selected="selected">Totes</option>
																									<option data-id="10" data-slug="salut-ambiental" value="10">Salut ambiental</option>
																									<option data-id="9" data-slug="seguretat-alimentaria" value="9">Seguretat alimentària</option>
																							</select>
										</div>
									</div>

									<div class="camp">
										<label>Cercar per subàrea</label>
										<div class="select_wrapper">
											<select class="subtema">
												<option class="all" value="*" data-slug="*" style="display: block;" selected="selected">Totes</option>
																									<option class="tema_9" data-id="171" value="programes-dinspeccio-sanitaria" disabled="disabled" style="display: none;">Programes d’inspecció sanitària</option>
																									<option class="tema_9" data-id="173" value="autoritzacions-i-registre-destabliments-alimentaris" disabled="disabled" style="display: none;">Autoritzacions i registre d’establiments alimentaris</option>
																									<option class="tema_9" data-id="174" value="certificats-sanitaris-per-a-lexportacio-daliments" disabled="disabled" style="display: none;">Certificats sanitaris per a l’exportació d’aliments</option>
																									<option class="tema_10" data-id="110" value="aigua-de-consum" disabled="disabled" style="display: none;">Aigua de consum</option>
																									<option class="tema_9" data-id="118" value="condicions-sanitaries-dels-establiments-i-productes-alimentaris" disabled="disabled" style="display: none;">Condicions sanitàries dels establiments i productes alimentaris</option>
																									<option class="tema_10" data-id="111" value="allotjaments-infantils-i-juvenils" disabled="disabled" style="display: none;">Allotjaments infantils i juvenils</option>
																									<option class="tema_9" data-id="119" value="autocontrols-dels-establiments-i-activitats-alimentaries" disabled="disabled" style="display: none;">Autocontrols dels establiments i activitats alimentàries</option>
																									<option class="tema_10" data-id="113" value="legionel%c2%b7la" disabled="disabled" style="display: none;">Legionel·la</option>
																									<option class="tema_9" data-id="122" value="denuncies-alertes-i-toxiinfeccions-alimentaries" disabled="disabled" style="display: none;">Denúncies, alertes i toxiinfeccions alimentàries</option>
																									<option class="tema_10" data-id="115" value="piscines" disabled="disabled" style="display: none;">Piscines</option>
																									<option class="tema_10" data-id="116" value="establiments-i-serveis-plaguicides" disabled="disabled" style="display: none;">Establiments i serveis plaguicides</option>
																									<option class="tema_10" data-id="117" value="tatuatges-pircings-i-micropigmentacio" disabled="disabled" style="display: none;">Tatuatges, pírcings i micropigmentació</option>
																							</select>
										</div>
									</div>

									<input class="form_button" type="button" value="Cercar" onclick="IUTTU.fn.filter_tramits()">
								</div>
							</li>
						</ul>
					</nav>



					<nav id="nav_cercar">
						<a href="javascript://" class="tornar">Tornar</a>

							<form role="search" method="get" id="searchform" class="searchform" action="https://www.aspb.cat/">
				<div>
					<label class="screen-reader-text" for="s">Cerca:</label>
					<input type="text" name="s" id="s">
					<input type="submit" id="searchsubmit" value="Cerca">
				</div>
			</form>
					</nav>



				
				<nav id="aridna" class="no_primer_nivel current_menu">
					<div class="header_menu">
					<!--- info 9513 -->					</div>
				</nav>

			

				

				<ul class="social_bar">
<li class="facebook"><a href="https://www.facebook.com/salutpublicabcn" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
<li class="twitter"><a href="https://twitter.com/salutpublicabcn" target="_blank"> <i class="fa fa-twitter" aria-hidden="true"></i>
 </a></li>
<li class="youtube"><a href="https://www.youtube.com/channel/UC1qJ5wfnP7fcT9pXkoe9opA" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
<li class="slideshare"><a href="http://www.slideshare.net/SalutpublicaBCN/" target="_blank"><i class="fa fa-slideshare" aria-hidden="true"></i></a></li>
<li class="linkedin"><a href="https://www.linkedin.com/company/ag%C3%A8ncia-de-salut-p%C3%BAblica-de-barcelona---aspb" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
</ul></div>
			</nav>



		</div>

		<div class="menu_overlay"></div>
	</section>

	<section id="contenido_wrapper" class="inner_wrapper">


		<div id="contenido" class="inner_wrapper">

			
							<h2>InfoABS 2017</h2>
			
			
									<div class="multimedia columna "><img src="content/infoABSMesa_2017.png" class="attachment-full size-full wp-post-image" alt="" width="613" height="860"></div>
				
			
			

			<div class="texto_html">
				<p>Conjunt d’indicadors de salut i els seus determinants per Àrees Bàsiques de Salut (ABS) l’any 2017</p>
<h3>Determinants de la salut</h3>
<p><strong>Característiques demogràfiques:</strong><br>
<a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_Estructura_Procedencia_Poblacio_2017.html" target="_blank" rel="noopener">Estructura i procedència de la població</a><br>
<a style="cursor: pointer" on:click={() => changeLens('map')}>Composició de les llars</a></p>
<p><strong>Conductes relacionades amb la salut:</strong><br>
<a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_SalutReproductiva_2017.html" target="_blank" rel="noopener">Salut reproductiva</a><br>
<a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_ConsumTabac_2015.html" target="_blank" rel="noopener">Consum de tabac, sobrepès i obesitat i activitat física</a></p>
<p><a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_CondicionsVidaTreball_2017.html" target="_blank" rel="noopener"><strong>Condicions de vida i de treball</strong></a></p>
<h3>Estat de salut</h3>
<p><a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_Mortalitat_2017.html" target="_blank" rel="noopener">Mortalitat</a><br>
Malalties de declaració obligatòria *<span style="color: #ff0000;"><a style="color: #ff0000;" href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_MDOS_2015.html" target="_blank" rel="noopener"><br>
</a></span><a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_ResultatsEmbaras_2017.html" target="_blank" rel="noopener">Resultats de l’embaràs</a><br>
<a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_EstatSalut_2015.html" target="_blank" rel="noopener">Estat de salut percebut, trastorns crònics i salut mental</a></p>
<h3>Ús de serveis sanitaris i pràctiques preventives</h3>
<p><a href="https://www.aspb.cat/docs/sisalutinfoabs/SISalutLlibresIndicadors/InfoABS_UsServeisSanitaris_2015.html" target="_blank" rel="noopener">Ús de serveis sanitaris</a></p>
<p>&nbsp;</p>
<p>*&nbsp;Les&nbsp;dades encara no estan disponibles. Es poden consultar la de l’any previ a l’<a href="https://www.aspb.cat/documents/infoabs-2016/">InfoABS de l’any 2016</a>. Aquest apartat s’actualitzarà tan aviat com sigui possible.</p>
			</div>

						<div class="meta dark">
				<h3>Aquesta informació es pot trobar a:</h3>
						<div class="row"><span class="tema_padre"><a href="https://www.aspb.cat/arees/la-salut-en-xifres/">La Salut en xifres</a></span><span class="tema_hijo"><a href="https://www.aspb.cat/arees/la-salut-en-xifres/la-salut-a-les-abs/">La salut a les ABS</a></span></div>					</div>
		

			<div class="tools">
			<!-- Go to www.addthis.com/dashboard to customize your tools -->
				<div class="addthis_inline_share_toolbox"></div>
			</div>


		</div>

		
	</section>



	<section id="pie_wrapper">
		<aside id="sidebar_pie" class="inner_wrapper">
			<div class="side" style="height: 454px;">
				<a href="https://www.aspb.cat/"><img src="content/logo_pequeno.png"></a>

			</div>
			<ul class="sidebar" style="height: 454px;">
				<li id="text_icl-7" class="widget widget_text_icl"><h2 class="widget_titulo">Contacte</h2>		<div class="textwidget"><div>
Seu central de l'Agència.<br>
Pl. Lesseps, 1.<br>
08023 Barcelona.
</div>
<div>
T. 932 384 545<br>
<a href="https://www.aspb.cat/contacte/">Enviar e-mail</a>
</div>
</div>
		</li><li id="text_icl-8" class="widget widget_text_icl"><h2 class="widget_titulo">Info</h2>		<div class="textwidget"><div>
· <a href="https://www.aspb.cat/registre">Registre ASPB</a><br>
· <a href="https://www.aspb.cat/l-agencia/treballar-a-laspb/">Treballar a la ASPB</a><br>
· <a href="https://www.aspb.cat/l-agencia/proveidors/">Perfil contractant</a>
</div>
<div>
· <a href="https://www.aspb.cat/informacio-privadesa">Informació de privadesa</a><br>
- <a href="https://www.aspb.cat/avis-legal/">Avís legal</a>
</div>
</div>
		</li><li id="text_icl-9" class="widget widget_text_icl"><h2 class="widget_titulo">Enllaços</h2>		<div class="textwidget"><div>
· <a href="http://www.barcelona.cat/">Ajuntament de Barcelona</a><br>
· <a href="http://salutweb.gencat.cat/">Departament de Salut</a><br>
· <a href="http://web.gencat.cat/">Generalitat de Catalunya</a>
</div>
</div>
		</li><li id="text_icl-10" class="widget widget_text_icl"><h2 class="widget_titulo">Certificat</h2>		<div class="textwidget"><div class="big">
<a href="https://www.aspb.cat/wp-content/uploads/2019/09/SegellEFQM400_ASPB_2019.pdf" target="_blank"><img src="content/certificat-1.png"></a>
<a style="float:right;width:auto" href="https://stamp.wma.comb.es/ca/seal/2267" target="_blank"><img src="content/imglogo.gif" alt="Web Mèdic Acreditat. Veure més informació" title="Web Mèdic Acreditat. Veure més informació" border="0"></a>
</div>
<div class="big">
<a style="width:auto;margin-right: 20px;" target="_blank" href="https://www.aspb.cat/wp-content/uploads/2019/07/Certificat_ISO9001_ASPB.pdf"><img src="content/aspb_certificat_iso9001_2015.png"></a>
<a style="width:auto;margin-right: 20px;" target="_blank" href="https://www.aspb.cat/wp-content/uploads/2019/07/Certificat_OHSAS18001_ASPB.pdf"><img src="content/aspb_certificat_ohsas_18001_2007.png"></a>
<a style="width:auto;margin-right: 20px;" href="https://www.aspb.cat/wp-content/uploads/2016/10/CERT_227_LE_1338_aigues.pdf"><img src="content/aspb_certificat_iso_17025.png"></a>
&nbsp;
</div>
</div>
		</li>			</ul>
		</aside>
	</section>
</div>

<!--<script>
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
  ga('create', 'UA-166291-4', 'auto');
  ga('send', 'pageview');
</script>-->



<script type="text/javascript" src="content/wp-embed.js"></script>
<script type="text/javascript">
/* <![CDATA[ */
var monsterinsights_frontend = {"js_events_tracking":"true","download_extensions":"doc,exe,js,pdf,ppt,tgz,zip,xls","inbound_paths":"[]","home_url":"https:\/\/www.aspb.cat","hash_tracking":"false"};
/* ]]> */
</script>
<script type="text/javascript" src="content/frontend.js"></script>
<script type="text/javascript" src="content/jquery.js"></script>
<script type="text/javascript" src="content/jquery-migrate.js"></script>
<script type="text/javascript">
/* <![CDATA[ */
var common_object = {"url_base":null};
/* ]]> */
</script>
<script type="text/javascript" src="content/site.js"></script>
<script>function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/app/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:'5e1809985715808824cab74f4a9bad2f'})})</script><script type="text/javascript">
	document.addEventListener( 'wpcf7mailsent', 
		function( event ) {
			console.log(event.detail.contactFormId);
						if ( '9691' == event.detail.contactFormId ) {
				location.href = 'https://www.aspb.cat/gracies/';
			}
					}, false );
</script>
<link rel="stylesheet" id="wp-block-library-css" href="content/style_002.css" type="text/css" media="all">
<link rel="stylesheet" id="slb_core-css" href="content/app.css" type="text/css" media="all">
<link rel="stylesheet" id="mc4wp-form-themes-css" href="content/form-themes.css" type="text/css" media="all">
<link rel="stylesheet" id="cf7cf-style-css" href="content/style.css" type="text/css" media="all">
<link rel="stylesheet" id="sedlex_styles-css" href="content/f7903471944f9ed05cb152bef99c3e5f3ab21da8.css" type="text/css" media="all">
<script type="text/javascript">
/* <![CDATA[ */
var wpcf7 = {"apiSettings":{"root":"https:\/\/www.aspb.cat\/wp-json\/contact-form-7\/v1","namespace":"contact-form-7\/v1"},"cached":"1"};
/* ]]> */
</script>
<script type="text/javascript" src="content/scripts.js"></script>
<script type="text/javascript" src="content/api.js"></script>
<script type="text/javascript" src="content/wp-gallery-custom-links.js"></script>
<script type="text/javascript">
/* <![CDATA[ */
var wpcf7cf_global_settings = {"ajaxurl":"https:\/\/www.aspb.cat\/wp-admin\/admin-ajax.php"};
/* ]]> */
</script>
<script type="text/javascript" src="content/scripts_002.js"></script>
<script type="text/javascript" id="slb_context">/* <![CDATA[ */if ( !!window.jQuery ) {(function($){$(document).ready(function(){if ( !!window.SLB ) { {$.extend(SLB, {"context":["public","user_guest"]});} }})})(jQuery);}/* ]]> */</script>
<script type="text/javascript">
( function( grecaptcha, sitekey, actions ) {
	var wpcf7recaptcha = {
		execute: function( action ) {
			grecaptcha.execute(
				sitekey,
				{ action: action }
			).then( function( token ) {
				var forms = document.getElementsByTagName( 'form' );
				for ( var i = 0; i < forms.length; i++ ) {
					var fields = forms[ i ].getElementsByTagName( 'input' );
					for ( var j = 0; j < fields.length; j++ ) {
						var field = fields[ j ];
						if ( 'g-recaptcha-response' === field.getAttribute( 'name' ) ) {
							field.setAttribute( 'value', token );
							break;
						}
					}
				}
			} );
		},
		executeOnHomepage: function() {
			wpcf7recaptcha.execute( actions[ 'homepage' ] );
		},
		executeOnContactform: function() {
			wpcf7recaptcha.execute( actions[ 'contactform' ] );
		},
	};
	grecaptcha.ready(
		wpcf7recaptcha.executeOnHomepage
	);
	document.addEventListener( 'change',
		wpcf7recaptcha.executeOnContactform, false
	);
	document.addEventListener( 'wpcf7submit',
		wpcf7recaptcha.executeOnHomepage, false
	);
} )(
	grecaptcha,
	'6Lfrc5IUAAAAAJ0rr1Xt9pXSAdPojjjnalNSYLNP',
	{"homepage":"homepage","contactform":"contactform"}
);
</script>
<script type="text/javascript" src="content/bcn-avisos.js"></script>
<script type="text/javascript"> 
var avisos = new Avisos({
	'id': 'bcnavisos',
	'token': '2751755d4a54352edf73de554a3f11b3',
	'lang': 'ca',
	'bootstrap': false,
	'extension': 'json'
});
</script>
<!-- Go to www.addthis.com/dashboard to customize your tools --> <script type="text/javascript" src="content/addthis_widget.js"></script><div style="visibility: hidden; height: 1px; width: 1px; position: absolute; top: -9999px; z-index: 100000;" id="_atssh"><iframe id="_atssh622" title="AddThis utility frame" style="height: 1px; width: 1px; position: absolute; top: 0px; z-index: 100000; border: 0px none; left: 0px;" src="https://s7.addthis.com/static/sh.f48a1a04fe8dbf021b4cda1d.html#rand=0.3851549121865987&amp;iit=1569850211940&amp;tmr=load%3D1569850211841%26core%3D1569850211870%26main%3D1569850211934%26ifr%3D1569850211956&amp;cb=0&amp;cdn=0&amp;md=0&amp;kw=&amp;ab=-&amp;dh=www.aspb.cat&amp;dr=https%3A%2F%2Fwww.google.com%2F&amp;du=https%3A%2F%2Fwww.aspb.cat%2Fdocuments%2Finfoabs-2017%2F&amp;href=https%3A%2F%2Fwww.aspb.cat%2Fdocuments%2Finfoabs-2017%2F&amp;dt=InfoABS%202017%20-%20ASPB%20-%20Ag%C3%A8ncia%20de%20Salut%20P%C3%BAblica%20de%20Barcelona&amp;dbg=0&amp;cap=tc%3D0%26ab%3D0&amp;inst=1&amp;jsl=1&amp;prod=undefined&amp;lng=ca&amp;ogt=height%2Cwidth%2Csecure_url%2Cimage%2Csite_name%2Curl%2Cdescription%2Ctype%3Darticle&amp;pc=men&amp;pub=ra-58d2aeccb5634ebc&amp;ssl=1&amp;sid=5d92036307766c9e&amp;srf=0.01&amp;ver=300&amp;xck=0&amp;xtr=0&amp;og=locale%3Dca_ES%26type%3Darticle%26title%3DInfoABS%25202017%2520-%2520ASPB%2520-%2520Ag%25C3%25A8ncia%2520de%2520Salut%2520P%25C3%25BAblica%2520de%2520Barcelona%26description%3DConjunt%2520d%25E2%2580%2599indicadors%2520de%2520salut%2520i%2520els%2520seus%2520determinants%2520per%2520%25C3%2580rees%2520B%25C3%25A0siques%2520de%2520Salut%2520(ABS)%2520l%25E2%2580%2599any%2520%25E2%2580%25A6%26url%3Dhttps%253A%252F%252Fwww.aspb.cat%252Fdocuments%252Finfoabs-2017%252F%26site_name%3DASPB%2520-%2520Ag%25C3%25A8ncia%2520de%2520Salut%2520P%25C3%25BAblica%2520de%2520Barcelona%26image%3Dhttps%253A%252F%252Fwww.aspb.cat%252Fwp-content%252Fuploads%252F2018%252F09%252FinfoABSMesa_2017.png%26secure_url%3Dhttps%253A%252F%252Fwww.aspb.cat%252Fwp-content%252Fuploads%252F2018%252F09%252FinfoABSMesa_2017.png%26width%3D613%26height%3D860&amp;csi=undefined&amp;rev=v8.27.11-wp&amp;ct=1&amp;xld=1&amp;xd=1"></iframe></div><style id="service-icons-0"></style>


<div><div class="grecaptcha-badge" data-style="bottomright" style="width: 256px; height: 60px; display: block; transition: right 0.3s ease 0s; position: fixed; bottom: 14px; right: -186px; box-shadow: gray 0px 0px 5px;"><div class="grecaptcha-logo"><iframe src="content/anchor.html" role="presentation" name="a-n8dhwgko68l4" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation" width="256" height="60" frameborder="0"></iframe></div><div class="grecaptcha-error"></div><textarea id="g-recaptcha-response-100000" name="g-recaptcha-response" class="g-recaptcha-response" style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;">03AOLTBLRnDJ1pV9gsTa9ZUL26R2jh02FYwyt_vndGBvybxzDFd7WgE7b5E97gHoP-jbI8BnjHDd11oAq1sJfWI6HjsYh2D3oi0cfr49K93BRu8GECYpvoM2N6KLtOEYSbRFYD5CjTFUVEKrmAW47TBBQB2Pim6AEkVLnOjmPagA8b6ejZKoI9hAPKKIoW2V1-fKGHY-qfGRcwz4bELcHtxxG2cle_WD7vuo46XNpQhBBCzG-tk1RWGtI9wUPJ0G_razZJI5sHZ4eQHMyKpB4by5MTcbI2FsEhA2udJ2GfzwgkNYkbdAStkHH91_o9U_fLpnVMZr2g6ewgwXj6Gg4lHLC5fcR9ppcTxeBNAZ_GyxoZUIS3BLAFIYUF8B61ICsxU1xrwNzXqucRDQE32IbXGM-ZYaMraVYY_2GPJoSo4Ab_8veu0YdGa9IHqBC6ZWJVhrhcklGjuAQb</textarea></div></div></body>
